// ** React Imports
import { createContext, useMemo, useState, useContext } from 'react'

// ** Config
import { selectedSegmentCampaignUrl, sendMailToMailpit } from 'src/configs/api'
import { useAuth } from 'src/hooks/useAuth'
import {
  campaignUrl,
  templateUrl,
  externalIdUrl,
  GetSettings,
  campaignChannelIgnoredValidationsUrl,
  generateSubjectUrl
} from 'src/configs/api'

import { AuthContext } from './AuthContext'
import { useAPI } from 'src/utils/api'
import { useToast } from 'src/@core/components/custom-Toast/customToast'
const defaultProvider = {
  tagListData: [],
  setTagListData: () => null,
  beefreeData: [],
  setBeefreeData: () => null,
  enableEmail: false,
  setEnableEmail: () => null,
  enableWhatsapp: false,
  setEnableWhatsapp: () => null,
  enableRCS: false,
  setEnableRCS: () => null,
  enableSms: false,
  setEnableSms: () => null,
  enableRCS: false,
  setEnableRCS: () => null,
  campaignname: '',
  setCampaignname: () => null,
  selectedSegments: [],
  setSelectedSegments: () => null,
  audienceSegments: [],
  setAudienceSegments: () => null,
  selectAudienceSettings: '',
  setSelectAudienceSettings: () => null,
  selectCategories: [],
  setSelectCategories: () => null,
  campaignListData: [],
  setCampaignListData: () => null,
  selectedSegmentCampaignList: [],
  setSelectedSegmentCampaignList: () => null,
  archiveListData: [],
  setArchiveListData: () => null,
  campaignMessageID: '',
  setCampaignMessageID: () => null,
  smsValue: '',
  setSmsValue: () => null,
  rcsValue: '',
  setRCSValue: () => null,
  emailValue: '',
  setEmailValue: () => null,
  whatsappValue: '',
  setWhatsappValue: () => null,
  campaignsubject: '',
  setCampaignsubject: () => null,
  preHeader: '',
  setPreHeader: () => null,
  attachments: [],
  setAttachments: () => null,
  fromEmail: '',
  setFromEmail: () => null,
  replyToEmail: '',
  setReplyToEmail: () => null,
  rawHtml: '',
  setRawHtml: () => null,
  rawJSON: '',
  setRawJSON: () => null,
  campaignSenderName: '',
  setCampaignSenderName: () => null,
  selectedCampaign: '',
  setSelectedCampaign: () => null,
  campaignSMSData: '',
  setCampaignSMSData: () => null,
  campaignWhatsappData: '',
  setCampaignWhatsappData: () => null,
  campaignEmailData: '',
  setCampaignEmailData: () => null,
  previewSMSData: '',
  setPreviewSMSData: () => null,
  previewWhatsappData: '',
  setPreviewWhatsappData: () => null,
  previewEmailData: '',
  setPreviewEmailData: () => null,
  SMSData: '',
  setSMSData: () => null,
  WhatsappData: '',
  setWhatsappData: () => null,
  EmailData: '',
  setEmailData: () => null,
  campaignSendDt: '',
  setCampaignSendDt: () => null,
  campaignSchedule: '',
  setCampaignSchedule: () => null,
  smsContentDescription: '',
  setSmsContentDescription: () => null,
  whatsappContentDescription: '',
  setWhatsappContentDescription: () => null,
  emailContentDescription: '',
  setEmailContentDescription: () => null,
  emailSubject: '',
  setEmailSubject: () => null,
  tags: [],
  setTags: () => null,
  mergetags: [],
  setMergeTags: () => null,
  editorID: 0,
  setEditorID: () => null,
  campaignCategoryList: [],
  setCampaignCategoryList: () => null,
  campaignDate: '',
  setCampaignDate: () => null,
  campaignChannelData: [],
  setCampaignChannelData: () => null,
  selectedChannelTab: '',
  setSelectedChannelTab: () => null,
  selectedPreviewTab: '',
  setSelectedPreviewTab: () => null,
  activeChannelStep: 0,
  setActiveChannelStep: () => null,
  activePreviewStep: 0,
  setActivePreviewStep: () => null,
  enableNextStep: false,
  setEnableNextstep: () => null,
  preHeaderError: '',
  setPreHeaderError: () => null,
  campaignDirection: '',
  setCamapaignDirection: () => null,
  isCampaignScheduleModified: false,
  setIsCampaignScheduleModified: () => null,
  isCampaignSetupModified: false,
  setIsCampaignSetupModified: () => null,
  isEmailContentModified: false,
  setIsEmailContentModified: () => null,
  isWhatsappContentModified: false,
  setIsWhatsappContentModified: () => null,
  isSmsContentModified: false,
  setIsSmsContentModified: () => null,
  isRCSContentModified: false,
  setIsRCSContentModified: () => null,
  mailpitID: '',
  setMailpitID: () => null,
  selectedChannels: [],
  setSelectedChannels: () => null,
  templateSupportedChannels: [],
  setTemplateSupportedChannels: () => null,
  isCampaignChannelsModified: false,
  setIsCampaignChannelsModified: () => null,
  previousUserChannels: [],
  setPreviousUserChannels: () => null,
  updatedEnabledChannels: [],
  setUpdatedEnabledChannels: () => null,
  updatedDisabledChannels: [],
  setUpdatedDisabledChannels: () => null,
  emailChannelId: '',
  setEmailChannelId: () => null,
  selectedCampaignChannelId: '',
  setSelectedCampignChannelId: () => null,
  whatsappChannelId: '',
  setWhatsappChannelId: () => null,
  smsChannelId: '',
  setSmsChannelId: () => null,
  rcsChannelId: '',
  setRCSChannelId: () => null,
  emailCampaignChannelId: '',
  setEmailCampaignChannelId: () => null,
  whatsappCampaignChannelId: '',
  setWhatsappCampaignChannelId: () => null,
  smsCampaignChannelId: '',
  setSmsCampaignChannelId: () => null,
  selectedTemplateId: null,
  setSelectedTemplateId: () => null,
  selectedEmailConfigId: null,
  setSelectedEmailConfigId: () => null,
  selectedSmsConfigId: null,
  setSelectedSmsConfigId: () => null,
  selectedWhatsappConfigId: null,
  setSelectedWhatsappConfigId: () => null,
  selectedRcsConfigId: null,
  setSelectedRcsConfigId: () => null,
  previousSelectedTemplateId: null,
  setPreviousSelectedTemplateId: () => null,
  selectedTemplateName: '',
  setSelectedTemplateName: () => null,
  emailCampaignContentId: '',
  setEmailCampaignContentId: () => null,
  whatsappCampaignContentId: '',
  setWhatsappCampaignContentId: () => null,
  smsCampaignContentId: '',
  setSmsCampaignContentId: () => null,
  whatsappHeaderType: 'none',
  setWhatsappHeaderType: () => null,
  whatsappHeaderLink: '',
  setWhatsappHeaderLink: () => null,
  whatsappHeaderMediaFile: '',
  setwhatsappHeaderMediaFile: () => null,
  whatsappFooterText: '',
  setWhatsappFooterText: () => null,
  whatsappSelectedTemplate: 'standard',
  setWhatsappSelectedTemplate: () => null,
  whatsappActionButtons: [],
  setWhatsappActionButtons: () => null,
  whatsappHeaderContent: '',
  setWhatsappHeaderContent: () => null,
  whatsappCarouselCards: [
    {
      id: 1,
      headerType: 'image',
      headerMediaFile: null,
      bodyText: '',
      actionButtons: []
    }
  ],
  setWhatsappCarouselCards: () => null,
  templateType: 'text',
  setTemplateType: () => null,
  textActionButtons: [],
  setTextActionButtons: () => null,
  smsFallbackText: '',
  setSmsFallbackText: () => null,
  rcards: [
    {
      id: 1,
      headerType: 'none',
      headerMediaFile: null,
      titleText: '',
      bodyText: '',
      actionButtons: [],
      cardOrientation: 'vertical',
      mediaHeight: 'short'
    }
  ],
  setRCards: () => null,
  emailConfigName: '',
  setEmailConfigName: () => null,
  whatsappConfigName: '',
  setWhatsappConfigName: () => null,
  smsConfigName: '',
  setSmsConfigName: () => null,
  rcsConfigName: '',
  setRCSConfigName: () => null,
  campaignsCount: 0,
  setCampaignsCount: () => null,
  selectedConfig: null,
  setSelectedConfig: () => null,
  trackEngagement: true,
  setTrackEngagement: () => null,
  campaignValidationCheckList: [],
  setCampaignValidationCheckList: () => null,
  isCampaignValid: false,
  setIsCampaignValid: () => null,
  isSelectedSendNow: false,
  setIsSelectedSendNow: () => null,
  selectedScheduleCampaign: false,
  setSelectedScheduleCampaign: () => null,
  isProcessing: false,
  setIsProcessing: () => null,
  isNextStepLoading: false,
  setIsNextStepLoading: () => null,
  isAiLoading: false,
  setIsAiLoading: () => null,
  selectedChannelId: '',
  setSelectedChannelId: () => null,
  campaignFilterList: [],
  setCampaignFilterList: () => null,
  campaignOtherFilterList: [],
  setCampaignOtherFilterList: () => null,
  hasTagFilter: false,
  setHasTagFilter: () => null,
  activeChannel: null,
  setActiveChannel: () => null,
  apiData: null,
  setApiData: () => null,
  campaignApiId: {
    sms: {
      layoutGroupId: '',
      unitId: '',
      componentId: ''
    },

    rcs: {
      text: {
        groupId: '', // was layoutGroupId
        unitId: '',
        messageComponentId: '',
        actionButtonComponentIds: [],
        fallbackComponentId: ''
      },
      standalone: {
        groupId: '', // layoutGroup.groupId of the standalone card
        unitId: '', // contentUnit.unitId of the standalone card
        mediaComponentId: '', // contentId of rcs_media
        titleComponentId: '', // contentId of rcs_card_title
        descComponentId: '', // contentId of rcs_card_description
        actionButtonIds: [], // array of contentIds of all action buttons
        fallback: {
          // fallback SMS block
          groupId: '', // fallback layoutGroupId
          unitId: '', // fallback unitId
          componentId: '' // fallback contentId
        }
      },

      carousel: {
        groupId: '', // 🔁 rename from layoutGroupId → groupId (important)
        cardUnits: [
          {
            unitId: '',
            mediaId: '',
            titleId: '',
            descId: '',
            actionIds: []
          }
        ],
        fallback: {
          groupId: '',
          unitId: '',
          componentId: ''
        }
      }
    },

    whatsapp: {
      standard: {
        // HEADER
        headerGroupId: '',
        headerUnitId: '',
        headerId: '',

        // BODY
        bodyGroupId: '',
        bodyUnitId: '',
        bodyId: '',

        // FOOTER (TEXT)
        footerGroupId: '',
        footerUnitId: '',
        footerId: '',

        // ACTION BUTTONS (Footer 2)
        actionGroupId: '', // groupId for the action footer group
        actionUnitId: '', // unitId for the action group
        actionButtonIds: [] // array of contentIds for each button
      },
      carousel: {
        // BODY BLOCK
        bodyGroupId: '', // layoutGroupId for body section
        bodyUnitId: '', // unitId of the body content
        bodyComponentId: '', // contentId for the body text

        // CARDS BLOCK
        rcardsGroupId: '', // layoutGroupId for card list

        rcards: [
          // Repeat for dynamic cards
          // This is ONE card structure:
          {
            unitId: '', // card unit ID
            headerId: '', // header component contentId
            bodyId: '', // body component contentId
            actionIds: [] // array of contentIds for actions
          }
        ]
      }

      // carousel: {
      //   body: {
      //     layoutGroupId: "",
      //     unitId: "",
      //     componentId: "" // whatsapp_body
      //   },

      //   cards: [
      //     // each card entry like:
      //     // {
      //     //   layoutGroupId: "",
      //     //   unitId: "",
      //     //   headerId: "",
      //     //   bodyId: "",
      //     //   footerId: "",
      //     //   actionIds: []
      //     // }
      //   ]
      // }
    },

    email: {
      subject: {
        layoutGroupId: '',
        unitId: '',
        componentId: ''
      },
      preheader: {
        layoutGroupId: '',
        unitId: '',
        componentId: ''
      },
      body: {
        layoutGroupId: '',
        unitId: '',
        componentId: ''
      },
      attachments: {
        groupId: '',
        unitId: '',
        componentId: ''
      }
    }
  },

  setCampaignApiId: () => null,
  whatsappExternalTemplateId: '',
  setWhatsappExternalTemplateId: () => null,
  rcsExternalTemplateId: '',
  setRcsExternalTemplateId: () => null,
  smsExternalTemplateId: '',
  setSmsExternalTemplateId: () => null,
  whatsappVendorDataId: '',
  setWhatsappVendorDataId: () => null,
  rcsVendorDataId: '',
  setRcsVendorDataId: () => null,
  smsvendorDataId: '',
  setSmsVendorDataId: () => null,
  whatsappExternalTemplateData: '',
  setWhatsappExternalTemplateData: () => null,
  rcsExternalTemplateData: '',
  setRcsExternalTemplateData: () => null,
  smsExternalTemplateData: '',
  setSmsExternalTemplateData: () => null,
  campaignActiveStep: 0,
  setCampaignActiveStep: () => null
}
const CampaignContext = createContext(defaultProvider)

const CampaignProvider = ({ children }) => {
  const {
    setLoading,
    setVerifiedSmtpConfigList,
    setVerifiedRcsSmtpConfigList,
    setVerifiedSmsSmtpConfigList,
    setVerifiedWhatsappSmtpConfigList
  } = useContext(AuthContext)

  const [campaignApiId, setCampaignApiId] = useState(defaultProvider.campaignApiId)

  const [tagListData, setTagListData] = useState(defaultProvider.tagListData)

  const [beefreeData, setBeefreeData] = useState(defaultProvider.beefreeData)

  const [enableEmail, setEnableEmail] = useState(defaultProvider.enableEmail)

  const [enableWhatsapp, setEnableWhatsapp] = useState(defaultProvider.enableWhatsapp)

  const [enableRCS, setEnableRCS] = useState(defaultProvider.enableRCS)

  const [enableSms, setEnableSms] = useState(defaultProvider.enableSms)

  const [campaignname, setCampaignname] = useState(defaultProvider.campaignname)

  const [selectedSegments, setSelectedSegments] = useState(defaultProvider.selectedSegments)

  const [audienceSegments, setAudienceSegments] = useState(defaultProvider.audienceSegments)

  const [selectAudienceSettings, setSelectAudienceSettings] = useState(defaultProvider.selectAudienceSettings)

  const [selectCategories, setSelectCategories] = useState(defaultProvider.selectCategories)

  const [campaignListData, setCampaignListData] = useState(defaultProvider.campaignListData)
  const [whatsappExternalTemplateId, setWhatsappExternalTemplateId] = useState(
    defaultProvider.whatsappExternalTemplateId
  )
  const [rcsExternalTemplateId, setRcsExternalTemplateId] = useState(defaultProvider.rcsExternalTemplateId)
  const [smsExternalTemplateId, setSmsExternalTemplateId] = useState(defaultProvider.smsExternalTemplateId)
  const [whatsappVendorDataId, setWhatsappVendorDataId] = useState(defaultProvider.whatsappVendorDataId)
  const [rcsVendorDataId, setRcsVendorDataId] = useState(defaultProvider.rcsVendorDataId)
  const [smsVendorDataId, setSmsVendorDataId] = useState(defaultProvider.smsVendorDataId)
  const [whatsappExternalTemplateData, setWhatsappExternalTemplateData] = useState(
    defaultProvider.whatsappExternalTemplateData
  )
  const [rcsExternalTemplateData, setRcsExternalTemplateData] = useState(defaultProvider.rcsExternalTemplateData)
  const [smsExternalTemplateData, setSmsExternalTemplateData] = useState(defaultProvider.smsExternalTemplateData)

  const [selectedSegmentCampaignList, setSelectedSegmentCampaignList] = useState(
    defaultProvider.selectedSegmentCampaignList
  )

  const [campaignCategoryList, setCampaignCategoryList] = useState(defaultProvider.campaignCategoryList)

  const [campaignChannelData, setCampaignChannelData] = useState(defaultProvider.campaignChannelData)

  const [archiveListData, setArchiveListData] = useState(defaultProvider.archiveListData)

  const [, setCampaignMessageID] = useState(defaultProvider.campaignMessageID)

  const [selectedCampaign, setSelectedCampaign] = useState(defaultProvider.selectedCampaign)

  const [campaignSMSData, setCampaignSMSData] = useState(defaultProvider.campaignSMSData)

  const [campaignWhatsappData, setCampaignWhatsappData] = useState(defaultProvider.campaignWhatsappData)

  const [campaignEmailData, setCampaignEmailData] = useState(defaultProvider.campaignEmailData)

  const [previewSMSData, setPreviewSMSData] = useState(defaultProvider.previewSMSData)

  const [previewWhatsappData, setPreviewWhatsappData] = useState(defaultProvider.previewWhatsappData)

  const [previewEmailData, setPreviewEmailData] = useState(defaultProvider.previewEmailData)

  const [SMSData, setSMSData] = useState(defaultProvider.SMSData)

  const [WhatsappData, setWhatsappData] = useState(defaultProvider.WhatsappData)

  const [EmailData, setEmailData] = useState(defaultProvider.EmailData)

  const [campaignSendDt, setCampaignSendDt] = useState(defaultProvider.campaignSendDt)

  const [campaignSchedule, setCampaignSchedule] = useState(defaultProvider.campaignSchedule)

  const [selectedChannelTab, setSelectedChannelTab] = useState(defaultProvider.selectedChannelTab)

  const [selectedPreviewTab, setSelectedPreviewTab] = useState(defaultProvider.selectedPreviewTab)

  const [selectedCampaignChannelId, setSelectedCampignChannelId] = useState(defaultProvider.selectedCampaignChannelId)

  const [emailChannelId, setEmailChannelId] = useState(defaultProvider.emailChannelId)

  const [rcsChannelId, setRCSChannelId] = useState(defaultProvider.rcsChannelId)

  const [whatsappChannelId, setWhatsappChannelId] = useState(defaultProvider.whatsappChannelId)

  const [smsChannelId, setSmsChannelId] = useState(defaultProvider.smsChannelId)

  const [emailCampaignChannelId, setEmailCampaignChannelId] = useState(defaultProvider.emailCampaignChannelId)

  const [whatsappCampaignChannelId, setWhatsappCampaignChannelId] = useState(defaultProvider.whatsappCampaignChannelId)

  const [smsCampaignChannelId, setSmsCampaignChannelId] = useState(defaultProvider.smsCampaignChannelId)

  const [smsContentDescription, setSmsContentDescription] = useState(defaultProvider.smsContentDescription)

  const [whatsappContentDescription, setWhatsappContentDescription] = useState(
    defaultProvider.whatsappContentDescription
  )

  const [emailContentDescription, setEmailContentDescription] = useState(defaultProvider.emailContentDescription)

  const [emailSubject, setEmailSubject] = useState(defaultProvider.emailSubject)

  const [smsValue, setSmsValue] = useState(defaultProvider.smsValue)

  const [rcsValue, setRCSValue] = useState(defaultProvider.rcsValue)

  const [emailValue, setEmailValue] = useState(defaultProvider.emailValue)

  const [whatsappValue, setWhatsappValue] = useState(defaultProvider.whatsappValue)

  const [campaignsubject, setCampaignsubject] = useState(defaultProvider.campaignsubject)

  const [preHeader, setPreHeader] = useState(defaultProvider.preHeader)

  const [attachments, setAttachments] = useState(defaultProvider.attachments)

  const [fromEmail, setFromEmail] = useState(defaultProvider.fromEmail)

  const [replyToEmail, setReplyToEmail] = useState(defaultProvider.replyToEmail)

  const [rawHtml, setRawHtml] = useState(defaultProvider.rawHtml)

  const [rawJSON, setRawJSON] = useState(defaultProvider.rawJSON)

  const [campaignSenderName, setCampaignSenderName] = useState(defaultProvider.campaignSenderName)

  const [tags, setTags] = useState(defaultProvider.tags)

  const [mergetags, setMergeTags] = useState(defaultProvider.mergetags)

  const [editorID, setEditorID] = useState(defaultProvider.editorID)

  const [campaignDate, setCampaignDate] = useState(defaultProvider.campaignDate)

  const [activeChannelStep, setActiveChannelStep] = useState(defaultProvider.activeChannelStep)

  const [activePreviewStep, setActivePreviewStep] = useState(defaultProvider.activePreviewStep)

  const [enableNextStep, setEnableNextstep] = useState(defaultProvider.enableNextStep)

  const [preHeaderError, setPreHeaderError] = useState(defaultProvider.preHeaderError)

  const [campaignDirection, setCamapaignDirection] = useState(defaultProvider.campaignDirection)

  const [isCampaignScheduleModified, setIsCampaignScheduleModified] = useState(
    defaultProvider.isCampaignScheduleModified
  )
  const [templateType, setTemplateType] = useState(defaultProvider.templateType)
  const [rcards, setRCards] = useState(defaultProvider.rcards)
  const [isCampaignSetupModified, setIsCampaignSetupModified] = useState(defaultProvider.isCampaignSetupModified)

  // Inline save status (replaces the toast for step-0 campaign save) — { type: 'success'|'error', message } | null
  const [campaignSaveStatus, setCampaignSaveStatus] = useState(null)

  const [isEmailContentModified, setIsEmailContentModified] = useState(defaultProvider.isEmailContentModified)

  const [isWhatsappContentModified, setIsWhatsappContentModified] = useState(defaultProvider.isWhatsappContentModified)

  const [isSmsContentModified, setIsSmsContentModified] = useState(defaultProvider.isSmsContentModified)

  const [isRCSContentModified, setIsRCSContentModified] = useState(defaultProvider.isRCSContentModified)

  const [mailpitID, setMailpitID] = useState(defaultProvider.mailpitID)

  const [selectedChannels, setSelectedChannels] = useState(defaultProvider.selectedChannels)

  const [templateSupportedChannels, setTemplateSupportedChannels] = useState(defaultProvider.templateSupportedChannels)

  const [previousUserChannels, setPreviousUserChannels] = useState(defaultProvider.previousUserChannels)

  const [updatedEnabledChannels, setUpdatedEnabledChannels] = useState(defaultProvider.updatedEnabledChannels)

  const [updatedDisabledChannels, setUpdatedDisabledChannels] = useState(defaultProvider.updatedDisabledChannels)

  const [selectedChannelId, setSelectedChannelId] = useState(defaultProvider.selectedChannelId)

  const [isCampaignChannelsModified, setIsCampaignChannelsModified] = useState(
    defaultProvider.isCampaignChannelsModified
  )
  const [selectedTemplateId, setSelectedTemplateId] = useState(defaultProvider.selectedTemplateId)

  // Tracks which "Select Content" radio option is active in TemplateList.js
  // ('Start from a Template' vs 'Build Your Own Content'). Lives here (not
  // as local state in TemplateList.js) because setup-step validation, which
  // runs from CamapignStepList.js, needs to tell "Build Your Own, no
  // template needed" apart from "Start from a Template but none picked yet"
  // — both look identical if you only look at `selectedTemplateId` being empty.
  const [isTemplateModeSelected, setIsTemplateModeSelected] = useState(false)

  const [selectedEmailConfigId, setSelectedEmailConfigId] = useState(defaultProvider.selectedEmailConfigId)
  const [selectedSmsConfigId, setSelectedSmsConfigId] = useState(defaultProvider.selectedSmsConfigId)
  const [selectedWhatsappConfigId, setSelectedWhatsappConfigId] = useState(defaultProvider.selectedWhatsappConfigId)
  const [selectedRcsConfigId, setSelectedRcsConfigId] = useState(defaultProvider.selectedRcsConfigId)

  const [previousSelectedTemplateId, setPreviousSelectedTemplateId] = useState(
    defaultProvider.previousSelectedTemplateId
  )

  const [emailCampaignContentId, setEmailCampaignContentId] = useState(defaultProvider.emailCampaignContentId)

  const [whatsappCampaignContentId, setWhatsappCampaignContentId] = useState(defaultProvider.whatsappCampaignContentId)

  const [smsCampaignContentId, setSmsCampaignContentId] = useState(defaultProvider.smsCampaignContentId)

  const [emailConfigName, setEmailConfigName] = useState(defaultProvider.emailConfigName)

  const [whatsappConfigName, setWhatsappConfigName] = useState(defaultProvider.whatsappConfigName)

  const [smsConfigName, setSmsConfigName] = useState(defaultProvider.smsConfigName)

  const [rcsConfigName, setRCSConfigName] = useState(defaultProvider.rcsConfigName)

  const [campaignsCount, setCampaignsCount] = useState(defaultProvider.campaignsCount)

  const [selectedConfig, setSelectedConfig] = useState(defaultProvider.selectedConfig)

  const [trackEngagement, setTrackEngagement] = useState(defaultProvider.defaultProvider)

  const [isCampaignValid, setIsCampaignValid] = useState(defaultProvider.isCampaignValid)

  const [isSelectedSendNow, setIsSelectedSendNow] = useState(defaultProvider.isSelectedSendNow)

  const [selectedScheduleCampaign, setSelectedScheduleCampaign] = useState(defaultProvider.selectedScheduleCampaign)

  const [isProcessing, setIsProcessing] = useState(defaultProvider.isProcessing)

  const [isNextStepLoading, setIsNextStepLoading] = useState(defaultProvider.isNextStepLoading)

  const [isAiLoading, setIsAiLoading] = useState(defaultProvider.isAiLoading)

  const [campaignValidationCheckList, setCampaignValidationCheckList] = useState(
    defaultProvider.campaignValidationCheckList
  )

  const [campaignFilterList, setCampaignFilterList] = useState(defaultProvider.templateFilterList)
  const [campaignOtherFilterList, setCampaignOtherFilterList] = useState(defaultProvider.templateOtherFilterList)
  const [campaignActiveStep, setCampaignActiveStep] = useState(0)
  const [hasTagFilter, setHasTagFilter] = useState(defaultProvider.hasTagFilter)

  const [selectedTemplateName, setSelectedTemplateName] = useState(defaultProvider.selectedTemplateName)

  const [whatsappHeaderType, setWhatsappHeaderType] = useState(defaultProvider.whatsappHeaderType)
  const [whatsappHeaderMediaFile, setwhatsappHeaderMediaFile] = useState(defaultProvider.whatsappHeaderMediaFile)
  const [whatsappFooterText, setWhatsappFooterText] = useState(defaultProvider.whatsappFooterText)
  const [whatsappSelectedTemplate, setWhatsappSelectedTemplate] = useState(defaultProvider.whatsappSelectedTemplate)
  const [whatsappActionButtons, setWhatsappActionButtons] = useState(defaultProvider.whatsappActionButtons)
  const [whatsappHeaderContent, setWhatsappHeaderContent] = useState(defaultProvider.whatsappHeaderContent)
  const [whatsappCarouselCards, setWhatsappCarouselCards] = useState(defaultProvider.whatsappCarouselCards)
  const [whatsappHeaderLink, setWhatsappHeaderLink] = useState(defaultProvider.whatsappHeaderLink)
  const [textActionButtons, setTextActionButtons] = useState(defaultProvider.textActionButtons)
  const [smsFallbackText, setSmsFallbackText] = useState(defaultProvider.smsFallbackText)
  const [activeChannel, setActiveChannel] = useState(defaultProvider.activeChannel)
  const [apiData, setApiData] = useState(defaultProvider.apiData)

  const getExternalTemplateDetails = async id => {
    try {
      const response = await api.get(`${externalIdUrl}/${id}/field-mapping`)
      if (response?.status === 200 || response?.status === 201) {
        return response?.data?.data
      }
    } catch {
      return false
    }
  }
  const { showInfo } = useToast()
  const resetCampaign = async () => {
    setLoading(true)
    setSelectedCampaign(null)
    setIsCampaignSetupModified(false)
    setSelectedTemplateId(null)
    setPreviousSelectedTemplateId(null)
    setSelectedEmailConfigId(null)

    setSelectedSmsConfigId(null)
    // setExternalTemplateCampaignId('')
    setSelectedWhatsappConfigId(null)
    setWhatsappHeaderLink('')
    setSelectedRcsConfigId(null)
    setCampaignname('')
    setIsCampaignChannelsModified(false)
    setEnableEmail(false)
    setEnableWhatsapp(false)
    setEnableSms(false)
    setEnableRCS(false)
    setSelectedChannels([])
    setTemplateSupportedChannels([])
    setUpdatedEnabledChannels([])
    setUpdatedDisabledChannels([])
    setPreviousUserChannels([])
    setSelectedSegments([])
    setAudienceSegments([])
    setSelectAudienceSettings(null)
    setSmsContentDescription('')
    setSmsValue('')
    setRCSValue('')
    setSelectedCampignChannelId('')
    setEmailChannelId('')
    setWhatsappChannelId('')
    setSmsChannelId('')
    setRCSChannelId('')
    setEmailCampaignChannelId('')
    setWhatsappCampaignChannelId('')
    setSmsCampaignChannelId('')
    setWhatsappContentDescription('')
    setWhatsappValue('')
    setCampaignSenderName('')
    setEmailValue('')
    setMailpitID('')
    setCampaignsubject('')
    setFromEmail('')
    setSelectCategories(null)
    setReplyToEmail('')
    setPreHeader('')
    setAttachments([])
    setEmailContentDescription('')
    setRawHtml('')
    setRawJSON('')
    setPreviewSMSData('')
    setPreviewWhatsappData('')
    setPreviewEmailData('')
    setCampaignWhatsappData('')
    setCampaignEmailData('')
    setEditorID('')
    setTags([])
    setEmailCampaignContentId('')
    setWhatsappCampaignContentId('')
    setSmsCampaignContentId('')
    setVerifiedSmtpConfigList([])
    setVerifiedWhatsappSmtpConfigList([])
    setVerifiedSmsSmtpConfigList([])
    setVerifiedRcsSmtpConfigList([])
    setEmailConfigName('')
    setFromEmail('')
    setReplyToEmail('')
    setWhatsappConfigName('')
    setSmsConfigName('')
    setRCSConfigName('')
    setCampaignValidationCheckList([])
    setSelectedConfig(null)
    setLoading(false)
    setIsCampaignScheduleModified(false)
    setTrackEngagement(true)
    setIsCampaignValid(false)
    setSelectedScheduleCampaign(false)
    setIsAiLoading(false)
    setSelectedTemplateName('')

    setWhatsappHeaderType('none')

    setwhatsappHeaderMediaFile('')
    setWhatsappFooterText('')
    setWhatsappSelectedTemplate('standard')
    setWhatsappActionButtons([])
    setWhatsappHeaderContent('')
    setWhatsappValue('')
    setWhatsappFooterText('')
    setWhatsappHeaderType('none')
    setWhatsappHeaderContent('')
    // setWhatsappHeaderMediaFile(null)
    setWhatsappActionButtons([])
    setIsWhatsappContentModified(false)
    setIsRCSContentModified(false)
    setIsSmsContentModified(false)
    setIsEmailContentModified(false)
    setWhatsappExternalTemplateId('')
    setRcsExternalTemplateId('')
    setSmsExternalTemplateId('')
    setWhatsappExternalTemplateData('')
    setRcsExternalTemplateData('')
    setSmsExternalTemplateData('')
    setWhatsappVendorDataId('')
    setRcsVendorDataId('')
    setSmsVendorDataId('')

    setWhatsappCarouselCards([
      {
        id: 1,
        headerType: 'image',
        headerMediaFile: null,
        bodyText: '',
        actionButtons: []
      }
    ])
    setTextActionButtons([])
    setSmsFallbackText('')
    setTemplateType('text')
    setRCSValue('')

    setRCards([
      {
        id: 1,
        headerType: 'image',
        headerMediaFile: null,
        titleText: '',
        bodyText: '',
        actionButtons: [],
        cardOrientation: 'vertical',
        mediaHeight: 'short'
      }
    ])
    setCampaignApiId({
      sms: {
        layoutGroupId: '',
        unitId: '',
        componentId: ''
      },

      rcs: {
        text: {
          groupId: '', // was layoutGroupId
          unitId: '',
          messageComponentId: '',
          actionButtonComponentIds: [],
          fallbackComponentId: ''
        },
        standalone: {
          groupId: '', // layoutGroup.groupId of the standalone card
          unitId: '', // contentUnit.unitId of the standalone card
          mediaComponentId: '', // contentId of rcs_media
          titleComponentId: '', // contentId of rcs_card_title
          descComponentId: '', // contentId of rcs_card_description
          actionButtonIds: [], // array of contentIds of all action buttons
          fallback: {
            // fallback SMS block
            groupId: '', // fallback layoutGroupId
            unitId: '', // fallback unitId
            componentId: '' // fallback contentId
          }
        },

        carousel: {
          groupId: '', // 🔁 rename from layoutGroupId → groupId (important)
          rcardUnits: [
            {
              unitId: '',
              mediaId: '',
              titleId: '',
              descId: '',
              actionIds: []
            }
          ],
          fallback: {
            groupId: '',
            unitId: '',
            componentId: ''
          }
        }
      },

      whatsapp: {
        standard: {
          // HEADER
          headerGroupId: '',
          headerUnitId: '',
          headerId: '',

          // BODY
          bodyGroupId: '',
          bodyUnitId: '',
          bodyId: '',

          // FOOTER (TEXT)
          footerGroupId: '',
          footerUnitId: '',
          footerId: '',

          // ACTION BUTTONS (Footer 2)
          actionGroupId: '', // groupId for the action footer group
          actionUnitId: '', // unitId for the action group
          actionButtonIds: [] // array of contentIds for each button
        },
        carousel: {
          // BODY BLOCK
          bodyGroupId: '', // layoutGroupId for body section
          bodyUnitId: '', // unitId of the body content
          bodyComponentId: '', // contentId for the body text

          // CARDS BLOCK
          cardsGroupId: '', // layoutGroupId for card list

          cards: [
            // Repeat for dynamic cards
            // This is ONE card structure:
            {
              unitId: '', // card unit ID
              headerId: '', // header component contentId
              bodyId: '', // body component contentId
              actionIds: [] // array of contentIds for actions
            }
          ]
        }
      },

      email: {
        subject: {
          layoutGroupId: '',
          unitId: '',
          componentId: ''
        },
        preheader: {
          layoutGroupId: '',
          unitId: '',
          componentId: ''
        },
        body: {
          layoutGroupId: '',
          unitId: '',
          componentId: ''
        },
        attachments: {
          groupId: '',
          unitId: '',
          componentId: ''
        }
      }
    })
    setCampaignActiveStep(0)
    return Promise.resolve()
  }
  const api = useAPI()
  const getEmailPayload = (overrideHtml, overrideJson) => {
    const isUpdate = !!campaignApiId?.email?.header?.groupId
    const htmlContent = overrideHtml !== undefined ? overrideHtml : emailValue
    const jsonContent = overrideJson !== undefined ? overrideJson : rawJSON
    return {
      // "configuration": {},
      // "configuration": {
      //   // renderEngine,
      //   "editorId": editorID
      // },
      configuration: { editorId: editorID },
      channelConfiguration: {
        channelConfigId: selectedEmailConfigId,
        channelConfigName: emailConfigName,
        additionalInfo: {
          senderEmail: fromEmail,
          replayToEmail: replyToEmail,
          fromName: campaignSenderName
        }
      },
      layoutGroups: [
        {
          ...(isUpdate && { groupId: campaignApiId.email.header.groupId }),
          // "groupId": "019b35d8-a3eb-784a-a433-6064816498bc",
          layoutType: 'HEADER',
          configuration: {},
          contentUnits: [
            {
              ...(isUpdate && { unitId: campaignApiId.email.header.unitId }),
              // "unitId": "019b35d8-a3ec-7d86-8f81-e98c8c48b446",
              unitName: 'Header Title',
              components: [
                {
                  ...(isUpdate && { contentId: campaignApiId.email.header.contentId }),
                  //  "contentId": "019b35d8-a3f0-7624-92fe-4f89b5ca4941",
                  componentKey: 'subject',
                  componentCategory: 'HEADER',
                  dataType: 'TEXT',
                  translations: {
                    en: campaignsubject
                  }
                }
              ]
            }
          ]
        },
        ...(preHeader?.trim()
          ? [
              {
                ...(isUpdate && { groupId: campaignApiId.email.preheader.groupId }),
                //  "groupId": "019bc5bc-4612-78d2-ac39-20a8c3ca3412",
                layoutType: 'HEADER',
                configuration: {},
                contentUnits: [
                  {
                    ...(isUpdate && { unitId: campaignApiId.email.preheader.unitId }),
                    // "unitId": "019bc5bc-4613-7ae7-9a29-630eaf9f49e8",
                    unitName: 'Preheader_Text',
                    configuration: {},
                    components: [
                      {
                        ...(isUpdate && { contentId: campaignApiId.email.preheader.contentId }),
                        // "contentId": "019bc5bc-4615-7edf-91a9-6fb5868c6fbc",
                        componentLabel: '',
                        componentKey: 'preheader_text',
                        componentCategory: 'BODY',
                        dataType: 'TEXT',
                        translations: {
                          en: preHeader
                        },
                        configuration: {}
                      }
                    ]
                  }
                ]
              }
            ]
          : []),
        {
          ...(isUpdate && { groupId: campaignApiId.email.body.groupId }),
          // "groupId": "019b35d8-a3f4-79b2-8718-1c9e37ea02b2",
          layoutType: 'BLOCK',
          configuration: {},
          contentUnits: [
            {
              ...(isUpdate && { unitId: campaignApiId.email.body.unitId }),
              // "unitId": "019b35d8-a3f5-7c58-98f5-26dcc9f837cb",
              unitName: 'Body Content',
              components: [
                {
                  ...(isUpdate && { contentId: campaignApiId.email.body.contentId }),
                  // "contentId": "019b35d8-a3f7-7c91-ae99-389711db06a4",
                  componentKey: 'body_html',
                  componentCategory: 'BODY',
                  dataType: 'TEXT',
                  translations: {
                    en: htmlContent
                  }
                },
                ...(jsonContent
                  ? [
                      {
                        ...(isUpdate &&
                          campaignApiId.email.body.beefreeJsonId && {
                            contentId: campaignApiId.email.body.beefreeJsonId
                          }),
                        componentKey: 'beefree_json',
                        componentCategory: 'BODY',
                        dataType: 'JSON',
                        translations: {
                          en: typeof jsonContent === 'string' ? JSON.parse(jsonContent) : jsonContent
                        }
                      }
                    ]
                  : [])
              ]
            }
          ]
        },
        // ATTACHMENTS — only send this section when there are attachments to save,
        // or when an existing attachments group needs to be updated (e.g. cleared out).
        ...((attachments?.length > 0 || campaignApiId?.email?.attachments?.groupId)
          ? [
              {
                layoutType: 'SECTION',
                ...(campaignApiId?.email?.attachments?.groupId && { groupId: campaignApiId.email.attachments.groupId }),
                configuration: {},
                contentUnits: [
                  {
                    ...(campaignApiId?.email?.attachments?.unitId && { unitId: campaignApiId.email.attachments.unitId }),
                    unitName: 'Email Attachments',
                    // No component object when empty — keeps the backend's
                    // mandatory-content validation from flagging an optional,
                    // empty attachment.
                    components: attachments?.length > 0
                      ? [
                          {
                            ...(campaignApiId?.email?.attachments?.componentId && { contentId: campaignApiId.email.attachments.componentId }),
                            componentKey: 'email_attachment',
                            componentCategory: 'MEDIA',
                            dataType: 'JSON',
                            componentLabel: 'Email Attachment',
                            translations: {
                              en: attachments.map(attachment => ({
                                url: attachment.url,
                                name: attachment.name,
                                mediaType: attachment.mediaType,
                                mimeType: attachment.mimeType,
                                size: attachment.size
                              }))
                            }
                          }
                        ]
                      : []
                  }
                ]
              }
            ]
          : [])
      ]
    }
  }
  const getSmsPayloadConfiguration = () => {
    return {
      configuration: null,
      channelConfiguration: {
        channelConfigId: selectedSmsConfigId,
        channelConfigName: smsConfigName,
        additionalInfo: {}
      },
      layoutGroups: []
    }
  }

  const getSmsPayload = () => {
    if (smsExternalTemplateId) {
      return getSmsPayloadConfiguration()
    }
    const isUpdate = campaignApiId.sms.groupId && campaignApiId.sms.unitId && campaignApiId.sms.componentId
    return {
      configuration: null,
      channelConfiguration: {
        channelConfigId: selectedSmsConfigId,
        channelConfigName: smsConfigName,
        additionalInfo: {}
      },
      layoutGroups: [
        {
          ...(isUpdate && { groupId: campaignApiId.sms.groupId }),
          // "groupId": "019bc5bc-46b6-7d81-9fd2-c1ca80bcb99a",
          layoutType: 'SECTION',
          configuration: {},
          contentUnits: [
            {
              // "unitId": "019bc5bc-46b7-7b51-b928-d068e2b2416f",
              ...(isUpdate && { unitId: campaignApiId.sms.unitId }),
              unitName: 'Message Content',
              configuration: {},
              components: [
                {
                  ...(isUpdate && { contentId: campaignApiId.sms.contentId }),
                  // "contentId": "019bc5bc-46ba-7041-9344-9189cefd2d54",
                  componentLabel: '',
                  componentKey: 'message',
                  componentCategory: 'BODY',
                  dataType: 'TEXT',
                  translations: {
                    en: smsValue
                  },
                  configuration: {}
                }
              ]
            }
          ]
        }
      ]
    }
  }

  const getWhatsappStandardPayload = () => {
    const ids = campaignApiId?.whatsapp?.standard

    const isUpdate = Boolean(ids?.header?.contentId)

    return {
      configuration: {
        template_type: 'standard'
      },

      channelConfiguration: {
        channelConfigId: selectedWhatsappConfigId,
        channelConfigName: whatsappConfigName,
        additionalInfo: {}
      },

      layoutGroups: [
        // ================= HEADER =================
        {
          ...(isUpdate && { groupId: ids?.header?.groupId }),
          layoutType: 'HEADER',
          configuration: {},
          contentUnits: [
            {
              ...(isUpdate && { unitId: ids?.header?.unitId }),
              unitName: 'Header Title',
              configuration: {},
              components: [
                {
                  ...(isUpdate && { contentId: ids?.header?.contentId }),
                  componentLabel: '',
                  componentKey: 'whatsapp_header_title',
                  componentCategory: 'HEADER',
                  dataType: 'JSON',
                  translations: {
                    en: {
                      type: whatsappHeaderType,
                      value: whatsappHeaderContent
                    }
                  },
                  configuration: {}
                }
              ]
            }
          ]
        },

        // ================= BODY =================
        {
          ...(isUpdate && { groupId: ids?.body?.groupId }),
          layoutType: 'BLOCK',
          configuration: {},
          contentUnits: [
            {
              ...(isUpdate && { unitId: ids?.body?.unitId }),
              unitName: 'Body Content',
              configuration: {},
              components: [
                {
                  ...(isUpdate && { contentId: ids?.body?.contentId }),
                  componentLabel: '',
                  componentKey: 'whatsapp_body',
                  componentCategory: 'BODY',
                  dataType: 'TEXT',
                  translations: {
                    en: whatsappValue
                  },
                  configuration: {}
                }
              ]
            }
          ]
        },

        // ================= FOOTER TEXT =================
        ...(whatsappFooterText?.trim() && [
          {
            ...(isUpdate && { groupId: ids?.footer?.groupId }),
            layoutType: 'FOOTER',
            configuration: {},
            contentUnits: [
              {
                ...(isUpdate && { unitId: ids?.footer?.unitId }),
                unitName: 'Footer',
                configuration: {},
                components: [
                  {
                    ...(isUpdate && { contentId: ids?.footer?.contentId }),
                    componentLabel: '',
                    componentKey: 'whatsapp_footer',
                    componentCategory: 'FOOTER',
                    dataType: 'TEXT',
                    translations: {
                      en: whatsappFooterText
                    },
                    configuration: {}
                  }
                ]
              }
            ]
          }
        ]),

        // ================= ACTION BUTTONS =================
        {
          ...(isUpdate && { groupId: ids?.action?.[0]?.groupId }),
          layoutType: 'FOOTER',
          configuration: {},
          contentUnits: [
            {
              ...(isUpdate && { unitId: ids?.action?.[0]?.unitId }),
              unitName: 'Action',
              configuration: {},
              components: (whatsappActionButtons || []).map((btn, index) => ({
                ...(isUpdate && { contentId: ids?.action?.[index]?.contentId }),

                componentLabel: '',
                componentKey: 'whatsapp_action_button',
                componentCategory: 'FOOTER',
                dataType: 'JSON',

                translations: {
                  en:
                    btn.type === 'quick_reply'
                      ? {
                          type: 'quick_reply',
                          title: 'reply',
                          payload: btn.quickReplies?.map(q => q.title)
                        }
                      : btn.type === 'coupon_code'
                        ? {
                            type: btn.type,
                            title: 'coupon',
                            payload: btn.payload
                          }
                        : {
                            type: btn.type,
                            title: btn.title,
                            payload: btn.payload
                          }
                },

                configuration: {}
              }))
            }
          ]
        }
      ]
    }
  }

  const getWhatsappCarouselPayload = () => {
    const ids = campaignApiId?.whatsapp?.carousel
    const isUpdate = Boolean(ids?.body?.contentId)

    return {
      configuration: {
        template_type: 'carousel'
      },

      channelConfiguration: {
        channelConfigId: selectedWhatsappConfigId,
        channelConfigName: whatsappConfigName,
        additionalInfo: {
          senderEmail: fromEmail,
          replayToEmail: replyToEmail
        }
      },

      layoutGroups: [
        // ================= BODY BLOCK =================
        {
          ...(isUpdate && { groupId: ids?.body?.groupId }),
          layoutType: 'BLOCK',
          configuration: {},
          contentUnits: [
            {
              ...(isUpdate && { unitId: ids?.body?.unitId }),
              unitName: 'Body Content',
              configuration: {},
              components: [
                {
                  ...(isUpdate && { contentId: ids?.body?.contentId }),
                  componentLabel: '',
                  componentKey: 'whatsapp_body',
                  componentCategory: 'BODY',
                  dataType: 'TEXT',
                  translations: { en: whatsappValue },
                  configuration: {}
                }
              ]
            }
          ]
        },

        // ================= CARDS BLOCK =================
        {
          ...(isUpdate && { groupId: ids?.cardsGroupId }),
          layoutType: 'BLOCK',
          configuration: {},
          contentUnits: (whatsappCarouselCards || []).map((card, cardIndex) => ({
            ...(isUpdate && { unitId: ids?.cards?.[cardIndex]?.unitId }),

            unitName: `Card ${cardIndex + 1}`,
            configuration: {},

            components: [
              // ---------- HEADER ----------
              {
                ...(isUpdate && { contentId: ids?.cards?.[cardIndex]?.headerId }),

                componentLabel: '',
                componentKey: 'whatsapp_header_title',
                componentCategory: 'HEADER',
                dataType: 'JSON',

                translations: {
                  en: {
                    type: card.headerType || 'image',
                    value: card.headerMediaFile || ''
                  }
                },

                configuration: {}
              },

              // ---------- BODY ----------
              {
                ...(isUpdate && { contentId: ids?.cards?.[cardIndex]?.bodyId }),

                componentLabel: '',
                componentKey: 'whatsapp_content',
                componentCategory: 'BODY',
                dataType: 'TEXT',
                translations: { en: card.bodyText || '' },
                configuration: {}
              },

              // ---------- ACTION BUTTONS ----------
              ...(card.actionButtons || []).map((btn, btnIndex) => ({
                ...(isUpdate && {
                  contentId: ids?.cards?.[cardIndex]?.buttons?.[btnIndex]
                }),

                componentLabel: '',
                componentKey: 'whatsapp_action_button',
                componentCategory: 'FOOTER',
                dataType: 'JSON',

                translations: {
                  en:
                    btn.type === 'quick_reply'
                      ? {
                          type: 'quick_reply',
                          title: 'reply',
                          payload: btn.quickReplies?.map(q => q.title)
                        }
                      : btn.type === 'coupon_code'
                        ? {
                            type: btn.type,
                            title: 'coupon',
                            payload: btn.payload
                          }
                        : {
                            type: btn.type,
                            title: btn.title,
                            payload: btn.payload
                          }
                },

                configuration: {}
              }))
            ]
          }))
        }
      ]
    }
  }
  const getWhatsappPayloadConfiguration = () => {
    return {
      configuration: {},
      channelConfiguration: {
        channelConfigId: selectedWhatsappConfigId,
        channelConfigName: whatsappConfigName,
        additionalInfo: {
          senderEmail: fromEmail,
          replayToEmail: replyToEmail
        }
      },
      layoutGroups: []
    }
  }
  const getWhatsappPayload = () => {
    if (whatsappExternalTemplateId) {
      return getWhatsappPayloadConfiguration()
    } else {
      if (whatsappSelectedTemplate === 'standard') {
        return getWhatsappStandardPayload()
      } else if (whatsappSelectedTemplate === 'carousel') {
        return getWhatsappCarouselPayload()
      }
    }
  }

  const getRCSTextPayload = () => {
    const ids = campaignApiId?.rcs || {}
    const isUpdate = !!ids?.message?.contentId

    return {
      configuration: { template_type: 'text_message' },

      channelConfiguration: {
        channelConfigId: selectedRcsConfigId,
        channelConfigName: rcsConfigName,
        additionalInfo: null
      },

      layoutGroups: [
        {
          ...(isUpdate && { groupId: ids.message.groupId }),
          layoutType: 'BLOCK',
          configuration: {},
          contentUnits: [
            {
              ...(isUpdate && { unitId: ids.message.unitId }),
              unitName: 'Message Content',
              configuration: {},
              components: [
                {
                  ...(isUpdate && { contentId: ids.message.contentId }),
                  componentKey: 'rcs_message',
                  componentCategory: 'BODY',
                  dataType: 'TEXT',
                  translations: { en: rcsValue },
                  configuration: {}
                },
                ...textActionButtons.map((btn, i) => {
                  const existingButton = ids.actionButtons?.[i]
                  return {
                    ...(existingButton?.contentId && {
                      contentId: existingButton.contentId
                    }),
                    componentKey: 'rcs_action_button',
                    componentCategory: 'BODY',
                    dataType: 'JSON',
                    translations: {
                      en:
                        btn.type === 'quick_reply'
                          ? {
                              type: 'quick_reply',
                              title: 'reply',
                              payload: btn.quickReplies?.map(q => q.title)
                            }
                          : btn.type === 'coupon_code'
                            ? {
                                type: btn.type,
                                title: 'coupon',
                                payload: btn.payload
                              }
                            : {
                                type: btn.type,
                                title: btn.title,
                                payload: btn.payload
                              }
                    },
                    configuration: {}
                  }
                })
              ]
            }
          ]
        },

        smsFallbackText?.trim() && {
          ...(ids.fallback?.groupId && { groupId: ids.fallback.groupId }),
          layoutType: 'BLOCK',
          configuration: {},
          contentUnits: [
            {
              ...(ids.fallback?.unitId && { unitId: ids.fallback.unitId }),
              unitName: 'Fallback',
              configuration: {},
              components: [
                {
                  ...(ids.fallback?.contentId && { contentId: ids.fallback.contentId }),
                  componentKey: 'rcs_fallback_sms_message',
                  componentCategory: 'BODY',
                  dataType: 'TEXT',
                  translations: { en: smsFallbackText },
                  configuration: {}
                }
              ]
            }
          ]
        }
      ]
    }
  }
  const getRCSStandardPayload = () => {
    const ids = campaignApiId?.rcs?.richCards

    return {
      configuration: {
        template_type: 'rich_card_stand_alone'
      },
      channelConfiguration: {
        channelConfigId: selectedRcsConfigId,
        channelConfigName: rcsConfigName,
        additionalInfo: null
      },

      layoutGroups: [
        // ================= CARDS =================
        ...rcards.map((card, index) => ({
          ...(ids?.rcards?.[index]?.groupId && { groupId: ids.rcards[index].groupId }),
          layoutType: 'BLOCK',
          configuration: {
            media_height: card.mediaHeight,
            card_orientation: card.cardOrientation
          },

          contentUnits: [
            {
              ...(ids?.rcards?.[index]?.unitId && { unitId: ids.rcards[index].unitId }),
              unitName: 'Message Content',
              configuration: {},

              components: [
                {
                  ...(ids?.rcards?.[index]?.mediaId && { contentId: ids.rcards[index].mediaId }),
                  componentKey: 'rcs_media',
                  componentCategory: 'BODY',
                  dataType: 'JSON',
                  translations: {
                    en: {
                      type: card.headerType,
                      url: card.headerMediaFile
                    }
                  },
                  configuration: {}
                },
                {
                  ...(ids?.rcards?.[index]?.titleId && { contentId: ids.rcards[index].titleId }),
                  componentKey: 'rcs_card_title',
                  componentCategory: 'HEADER',
                  dataType: 'TEXT',
                  translations: { en: card.titleText },
                  configuration: {}
                },
                {
                  ...(ids?.rcards?.[index]?.descriptionId && { contentId: ids.rcards[index].descriptionId }),
                  componentKey: 'rcs_card_description',
                  componentCategory: 'BODY',
                  dataType: 'TEXT',
                  translations: { en: card.bodyText },
                  configuration: {}
                },

                // ---------- ACTION BUTTONS ----------
                ...card?.actionButtons?.map((btn, btnIndex) => ({
                  ...(ids?.rcards?.[index]?.actionIds?.[btnIndex] && {
                    contentId: ids.rcards[index].actionIds[btnIndex]
                  }),

                  componentKey: 'rcs_action_button',
                  componentCategory: 'BODY',
                  dataType: 'JSON',
                  translations: {
                    en:
                      btn.type === 'quick_reply'
                        ? {
                            type: 'quick_reply',
                            title: btn.title || 'reply',
                            payload: btn.quickReplies?.map(q => q.title) || []
                          }
                        : btn.type === 'coupon_code'
                          ? {
                              type: btn.type,
                              title: 'coupon',
                              payload: btn.payload
                            }
                          : {
                              type: btn.type,
                              title: btn.title,
                              payload: btn.payload
                            }
                  },
                  configuration: {}
                }))
              ]
            }
          ]
        })),

        // ================= FALLBACK =================
        smsFallbackText?.trim() && {
          ...(ids?.fallback?.groupId && { groupId: ids.fallback.groupId }),
          layoutType: 'BLOCK',
          configuration: {},
          contentUnits: [
            {
              ...(ids?.fallback?.unitId && { unitId: ids.fallback.unitId }),
              unitName: 'Fallback',
              configuration: {},
              components: [
                {
                  ...(ids?.fallback?.contentId && { contentId: ids.fallback.contentId }),
                  componentKey: 'rcs_fallback_sms_message',
                  componentCategory: 'BODY',
                  dataType: 'TEXT',
                  translations: { en: smsFallbackText },
                  configuration: {}
                }
              ]
            }
          ]
        }
      ]
    }
  }

  const getRCSCarouselPayload = () => {
    const existingIds = campaignApiId?.rcs?.carousel

    const isUpdate = !!existingIds?.rcards?.length

    return {
      configuration: {
        template_type: 'rich_card_carousel'
      },

      channelConfiguration: {
        channelConfigId: selectedRcsConfigId,
        channelConfigName: rcsConfigName,
        additionalInfo: null
      },

      layoutGroups: [
        // ================= CARDS =================
        ...rcards.map((card, cardIndex) => {
          const existingCard = existingIds?.rcards?.[cardIndex]

          return {
            ...(isUpdate && { groupId: existingCard?.groupId }),

            layoutType: 'BLOCK',

            configuration: {
              media_height: card.mediaHeight || 'short',
              card_orientation: card.cardOrientation || 'vertical'
            },

            contentUnits: [
              {
                ...(isUpdate && { unitId: existingCard?.unitId }),

                unitName: card.titleText || `Card ${cardIndex + 1}`,
                configuration: {},

                components: [
                  // -------- MEDIA --------
                  ...(card.headerMediaFile
                    ? [
                        {
                          ...(isUpdate && { contentId: existingCard?.mediaId }),
                          componentLabel: '',
                          componentKey: 'rcs_media',
                          componentCategory: 'HEADER',
                          dataType: 'JSON',
                          translations: {
                            en: {
                              type: card.headerType || 'image',
                              url: card.headerMediaFile
                            }
                          },
                          configuration: {}
                        }
                      ]
                    : []),

                  // -------- TITLE --------
                  ...(card.titleText
                    ? [
                        {
                          ...(isUpdate && { contentId: existingCard?.titleId }),
                          componentLabel: '',
                          componentKey: 'rcs_card_title',
                          componentCategory: 'HEADER',
                          dataType: 'TEXT',
                          translations: { en: card.titleText },
                          configuration: {}
                        }
                      ]
                    : []),

                  // -------- DESCRIPTION --------
                  ...(card.bodyText
                    ? [
                        {
                          ...(isUpdate && { contentId: existingCard?.descriptionId }),
                          componentLabel: '',
                          componentKey: 'rcs_card_description',
                          componentCategory: 'BODY',
                          dataType: 'TEXT',
                          translations: { en: card.bodyText },
                          configuration: {}
                        }
                      ]
                    : []),

                  // -------- ACTION BUTTONS --------
                  ...card?.actionButtons?.map((btn, btnIndex) => ({
                    ...(isUpdate && {
                      contentId: existingCard?.buttonIds?.[btnIndex]
                    }),

                    componentLabel: '',
                    componentKey: 'rcs_action_button',
                    componentCategory: 'BODY',
                    dataType: 'JSON',

                    translations: {
                      en:
                        btn.type === 'quick_reply'
                          ? {
                              type: 'quick_reply',
                              title: btn.title || 'reply',
                              payload: btn.quickReplies?.map(q => q.title)
                            }
                          : btn.type === 'coupon_code'
                            ? {
                                type: 'coupon_code',
                                title: 'coupon',
                                payload: btn.payload
                              }
                            : {
                                type: btn.type,
                                title: btn.title,
                                payload: btn.payload
                              }
                    },

                    configuration: {}
                  }))
                ]
              }
            ]
          }
        }),

        // ================= FALLBACK (ALWAYS LAST) =================
        smsFallbackText?.trim() && {
          ...(isUpdate && { groupId: existingIds?.fallback?.groupId }),

          layoutType: 'BLOCK',
          configuration: {},

          contentUnits: [
            {
              ...(isUpdate && { unitId: existingIds?.fallback?.unitId }),

              unitName: 'Fallback',
              configuration: {},

              components: [
                {
                  ...(isUpdate && { contentId: existingIds?.fallback?.contentId }),

                  componentLabel: '',
                  componentKey: 'rcs_fallback_sms_message',
                  componentCategory: 'BODY',
                  dataType: 'TEXT',
                  translations: { en: smsFallbackText },
                  configuration: {}
                }
              ]
            }
          ]
        }
      ]
    }
  }

  const getRCSPayloadConfiguration = () => {
    return {
      configuration: {},
      channelConfiguration: {
        channelConfigId: selectedRcsConfigId,
        channelConfigName: rcsConfigName,
        additionalInfo: null
      },
      layoutGroups: []
    }
  }

  const getRCSPayload = () => {
    if (rcsExternalTemplateId) {
      return getRCSPayloadConfiguration()
    }
    if (templateType === 'text') {
      return getRCSTextPayload()
    } else if (templateType === 'rich') {
      return getRCSStandardPayload()
    } else if (templateType === 'rich_carousel') {
      return getRCSCarouselPayload()
    }
  }
  const fetchTemplateForSingleChannel = async channelId => {
    try {
      if (!selectedTemplateId) {
        return
      }

      const responseTemplate = await getTemplate(selectedTemplateId)

      const templateChannel = responseTemplate?.channels?.find(ch => ch.channelId === channelId)

      if (!templateChannel) {
        return
      }

      switch (templateChannel.channelName.toLowerCase()) {
        case 'email':
          fetchEmailTemplateTranslation(selectedTemplateId, channelId)
          break

        case 'whatsapp':
          fetchWhatsappTemplateTranslation(selectedTemplateId, channelId)
          break

        case 'sms':
          fetchSMSTemplateTranslation(selectedTemplateId, channelId)
          break

        case 'rcs':
          fetchRCSTemplateTranslation(selectedTemplateId, channelId)
          break

        default:
          break
      }
    } catch {}
  }
  const GetTransactionalChannelTranslation = async channelId => {
    try {
      const response = await api.get(`${campaignUrl}/${selectedCampaign?.id}/channeldata/${channelId}`)

      const channelMessage = response?.data?.data
      return channelMessage
    } catch {}
  }
  const getQuickStats = async id => {
    try {
      const response = await api.get(`${campaignUrl}/${id}/stats`)
      return response?.data?.data
    } catch {}
  }
  const GetPromotionalChannelTranslation = async channelId => {
    try {
      const response = await api.get(`${campaignUrl}/${selectedCampaign?.id}/channeldata/${channelId}`)

      const channelMessage = response?.data?.data
      return channelMessage
    } catch {}
  }

  const validateCampaign = async selectedCampaignID => {
    try {
      // Validate step renders the checklist inline — no success/failure toast needed here.
      const response = await api.get(`${campaignUrl}/validate/${selectedCampaignID}`, { skipGlobalToast: true })
      const campaignValidationSummary = response?.data?.data || []
      setCampaignValidationCheckList(campaignValidationSummary)
      setIsCampaignValid(
        campaignValidationSummary?.validations?.every(channel => channel.validation_rules.every(rule => rule.result))
      )
      return true
    } catch {}
  }

  const updateIgnoredValidations = async (campaignId, channelId, { add = [], remove = [] } = {}) => {
    try {
      const response = await api.patch(
        campaignChannelIgnoredValidationsUrl(campaignId, channelId),
        { add, remove },
        { skipGlobalToast: true }
      )
      const ignoredValidations = response?.data?.data?.ignoredValidations ?? response?.data?.ignoredValidations ?? []
      return { ok: true, ignoredValidations }
    } catch (error) {
      const message = error?.response?.data?.message || error?.response?.data?.error || 'Failed to save ignore settings'
      return { ok: false, message }
    }
  }

  const getMergeTags = async () => {
    try {
      const response = await api.get(`${campaignUrl}/merge-tags`)
      setMergeTags(response?.data?.data.merge_tags)
    } catch {}
  }

  const sendCampaignMailToMailpit = async ({
    html,
    fromEmail: propFromEmail,
    senderName: propSenderName,
    replyTo: propReplyTo,
    subject: propSubject
  } = {}) => {
    try {
      const missingFields = []
      const finalHtml = html || emailValue
      const finalFromEmail = propFromEmail || fromEmail
      const finalSenderName = propSenderName || campaignSenderName
      const finalReplyTo = propReplyTo || replyToEmail
      const finalSubject = propSubject || campaignsubject

      if (!finalHtml?.trim()) {
        missingFields.push('Email content')
      }
      if (!finalFromEmail?.trim()) {
        missingFields.push('From Email')
      }
      if (!finalSenderName?.trim()) {
        missingFields.push('Sender Name')
      }
      if (!finalSubject?.trim()) {
        missingFields.push('Subject')
      }

      if (missingFields.length > 0) {
        showInfo(`${missingFields.join(', ')} is required.`)
        return
      }
      const emailPayload = {
        Attachments: [],
        Bcc: [],
        Cc: [],
        From: {
          Email: finalFromEmail,
          Name: finalSenderName
        },
        HTML: finalHtml,
        Headers: {},
        ReplyTo: finalReplyTo
          ? [
              {
                Email: finalReplyTo,
                Name: finalSenderName
              }
            ]
          : [],
        Subject: finalSubject,
        Tags: [],
        Text: ''
      }

      const response = await api.post(sendMailToMailpit, emailPayload)
      setMailpitID(response?.data?.id)

      return response?.status === 200
    } catch {}
  }
  const getSelectedSegmentCampaignList = async segments => {
    try {
      let query = ''
      segments.forEach((segment, index) => {
        query += `segmentId=${segment}`
        if (index < segments.length - 1) {
          query += '&'
        }
      })

      const response = await api.get(`${selectedSegmentCampaignUrl}?${query}`)

      setSelectedSegmentCampaignList(response?.data?.data)
    } catch {}
  }
  const fetchSmsTranslation = async (channelSmsId, type) => {
    const isPromotional = type === 'promotional'
    const isTransactional = type === 'transactional'

    if (selectedCampaign?.id && channelSmsId) {
      let translation = null

      if (isPromotional) {
        translation = await GetPromotionalChannelTranslation(channelSmsId)
      } else if (isTransactional) {
        translation = await GetTransactionalChannelTranslation(channelSmsId)
      }
      setSmsExternalTemplateId(translation?.externalTemplateId)

      if (translation?.externalTemplateId && translation?.vendorId) {
        const dataDetails = await getExternalTemplateDetails(translation?.externalTemplateId)
        setSmsExternalTemplateData(dataDetails)
        setSmsVendorDataId(translation?.vendorId)
        const channelConfigId = translation?.channelConfiguration?.channelConfigId
        const channelConfigName = translation?.channelConfiguration?.channelConfigName
        setSelectedSmsConfigId(channelConfigId)
        setSmsConfigName(channelConfigName)
      }

      setSelectedSmsConfigId(translation?.channelConfiguration?.channelConfigId)
      setSmsConfigName(translation?.channelConfiguration?.channelConfigName)

      const groupId = translation?.layoutGroups?.[0]?.groupId || ''
      const unitId = translation?.layoutGroups?.[0]?.contentUnits?.[0]?.unitId || ''
      const componentId = translation?.layoutGroups?.[0]?.contentUnits?.[0]?.components?.[0]?.contentId || ''
      const translationalSmsValue = translation?.layoutGroups?.[0]?.contentUnits?.[0]?.components?.[0]?.translations?.en
      setCampaignApiId(prev => ({
        ...prev,
        sms: {
          groupId,
          unitId,
          componentId
        }
      }))
      setSmsValue(translationalSmsValue)
    }
  }
  // idsOnly: after a save, the local UI state (subject/body/attachments/etc.) already
  // matches what was just submitted — re-fetching and overwriting it risks a
  // read-after-write race where the GET lands before the backend's write is visible
  // (most likely right when a field's group/component is created for the first time,
  // e.g. a campaign's first attachment). idsOnly=true only syncs campaignApiId's IDs
  // (needed so the next save updates instead of re-creating) without touching content.
  const fetchEmailTranslation = async (channelEmailId, type, idsOnly = false) => {
    const isPromotional = type === 'promotional'
    const isTransactional = type === 'transactional'
    if (selectedCampaign?.id && channelEmailId) {
      try {
        let translation = null

        if (isPromotional) {
          translation = await GetPromotionalChannelTranslation(channelEmailId)
        } else if (isTransactional) {
          translation = await GetTransactionalChannelTranslation(channelEmailId)
        }

        const configurationDetail = translation?.channelConfiguration
        setCampaignSenderName(configurationDetail?.additionalInfo?.fromName)
        setEmailConfigName(configurationDetail?.channelConfigName)
        setSelectedEmailConfigId(configurationDetail?.channelConfigId)
        setFromEmail(configurationDetail?.additionalInfo?.senderEmail)
        setReplyToEmail(configurationDetail?.additionalInfo?.replayToEmail)
        const extractEmailIds = responseData => {
          const data = responseData

          setEditorID(Number(data?.configuration?.editorId) || 2)
          if (!data?.layoutGroups?.length) {
            return null
          }

          let header = {},
            preheader = {},
            body = {},
            attachmentIds = {}

          data?.layoutGroups?.forEach(group => {
            group.contentUnits.forEach(unit => {
              unit.components.forEach(comp => {
                if (comp.componentKey === 'subject') {
                  header = {
                    groupId: group.groupId,
                    unitId: unit.unitId,
                    contentId: comp.contentId
                  }
                }
                if (comp.componentKey === 'preheader_text') {
                  preheader = {
                    groupId: group.groupId,
                    unitId: unit.unitId,
                    contentId: comp.contentId
                  }
                }
                if (comp.componentKey === 'body_html') {
                  body = {
                    groupId: group.groupId,
                    unitId: unit.unitId,
                    contentId: comp.contentId
                  }
                }
                // Also track beefree_json ID for updates
                if (comp.componentKey === 'beefree_json') {
                  if (!body.beefreeJsonId) {
                    body.beefreeJsonId = comp.contentId
                  }
                }
                if (comp.componentKey === 'email_attachment') {
                  attachmentIds = {
                    groupId: group.groupId,
                    unitId: unit.unitId,
                    componentId: comp.contentId
                  }
                }
              })
            })
          })

          return {
            channelId: data?.channelId,
            channelConfigId: data?.channelConfiguration?.channelConfigId,
            channelConfigName: data?.channelConfiguration?.channelConfigName,
            fromName: data?.channelConfiguration?.additionalInfo?.fromName,
            senderEmail: data?.channelConfiguration?.additionalInfo?.senderEmail,
            replayToEmail: data?.channelConfiguration?.additionalInfo?.replayToEmail,
            header,
            preheader,
            body,
            attachments: attachmentIds
          }
        }

        // Extract ALL IDs from response
        const emailIdsData = extractEmailIds(translation) // ✅ Pass translation (not translation.data)

        setCampaignApiId(prev => ({
          ...prev,
          email: emailIdsData
        }))

        // Extract content to UI states
        const extractContent = data => {
          let subject = '',
            preheader = '',
            body = '',
            json = null,
            attachmentList = []
          data.layoutGroups.forEach(group => {
            group.contentUnits.forEach(unit => {
              unit.components.forEach(comp => {
                const value = comp.translations?.en || ''
                if (comp.componentKey === 'subject') {
                  subject = value
                }
                if (comp.componentKey === 'preheader_text') {
                  preheader = value
                }
                if (comp.componentKey === 'body_html') {
                  body = value
                }
                if (comp.componentKey === 'beefree_json') {
                  json = value
                }
                // email_attachment stores its whole list under a single component
                // (translations.en is the array), unlike every other key here.
                if (comp.componentKey === 'email_attachment') {
                  attachmentList = value || []
                }
              })
            })
          })
          return { subject, preheader, body, json, attachments: attachmentList }
        }

        if (!idsOnly) {
          const content = extractContent(translation)
          setCampaignsubject(content.subject)
          setPreHeader(content.preheader)
          setEmailValue(content.body)
          setRawHtml(content.body) // keep rawHtml in sync — save path reads rawHtml, not emailValue
          setRawJSON(content.json) // Set the project data for the editor
          setAttachments(content.attachments)

          if (
            content?.body &&
            configurationDetail?.additionalInfo?.senderEmail &&
            configurationDetail?.additionalInfo?.fromName &&
            configurationDetail?.additionalInfo?.replayToEmail &&
            content.subject
          ) {
            await sendCampaignMailToMailpit({
              html: content.body,
              fromEmail: configurationDetail?.additionalInfo?.senderEmail,
              senderName: configurationDetail?.additionalInfo?.fromName,
              replyTo: configurationDetail?.additionalInfo?.replayToEmail,
              subject: content.subject
            })
          }
        }
        setEditorID(Number(translation?.configuration?.editorId) || 2)
        return Number(translation?.configuration?.editorId) || 2
      } catch {}
    }
  }
  const fetchWhatsappTranslation = async (channelWhatsappId, type) => {
    const isPromotional = type === 'promotional'
    const isTransactional = type === 'transactional'
    if (selectedCampaign.id && channelWhatsappId) {
      try {
        let translation = null

        if (isPromotional) {
          translation = await GetPromotionalChannelTranslation(channelWhatsappId)
        } else if (isTransactional) {
          translation = await GetTransactionalChannelTranslation(channelWhatsappId)
        }

        setWhatsappExternalTemplateId(translation?.externalTemplateId)
        if (translation?.externalTemplateId && translation?.vendorId) {
          const channelConfigId = translation?.channelConfiguration?.channelConfigId
          const channelConfigName = translation?.channelConfiguration?.channelConfigName
          setSelectedWhatsappConfigId(channelConfigId)
          setWhatsappConfigName(channelConfigName)
          const dataDetails = await getExternalTemplateDetails(translation?.externalTemplateId)
          setWhatsappExternalTemplateData(dataDetails)
          setWhatsappSelectedTemplate('')

          setWhatsappVendorDataId(translation?.vendorId)
        }

        const templateTypeFromAPI = translation?.configuration?.template_type // Fresh value

        if (templateTypeFromAPI === 'standard') {
          const extractWhatsappIds = data => {
            if (!data?.layoutGroups?.length) {
              return null
            }

            let header = {},
              body = {},
              footer = {},
              action = []

            data.layoutGroups.forEach(group => {
              group.contentUnits.forEach(unit => {
                unit.components.forEach(comp => {
                  if (comp.componentKey === 'whatsapp_header_title') {
                    header = {
                      groupId: group.groupId,
                      unitId: unit.unitId,
                      contentId: comp.contentId
                    }
                  }

                  if (comp.componentKey === 'whatsapp_body') {
                    body = {
                      groupId: group.groupId,
                      unitId: unit.unitId,
                      contentId: comp.contentId
                    }
                  }

                  if (comp.componentKey === 'whatsapp_footer') {
                    footer = {
                      groupId: group.groupId,
                      unitId: unit.unitId,
                      contentId: comp.contentId
                    }
                  }

                  if (comp.componentKey === 'whatsapp_action_button') {
                    action.push({
                      groupId: group.groupId,
                      unitId: unit.unitId,
                      contentId: comp.contentId
                    })
                  }
                })
              })
            })

            return {
              channelId: data.channelId,
              channelConfigId: data.channelConfiguration?.channelConfigId,
              channelConfigName: data.channelConfiguration?.channelConfigName,
              header,
              body,
              footer,
              action
            }
          }

          const whatsappIdsData = extractWhatsappIds(translation)

          setCampaignApiId(prev => ({
            ...prev,
            whatsapp: {
              ...prev?.whatsapp,
              standard: whatsappIdsData
            }
          }))

          const extractWhatsappContent = data => {
            let headerType = ''
            let headerValue = ''
            let body = ''
            let footer = ''
            let actions = []
            const actionButtonComponentIds = []

            data.layoutGroups.forEach(group => {
              group.contentUnits.forEach(unit => {
                unit.components.forEach(comp => {
                  const value = comp.translations?.en

                  if (comp.componentKey === 'whatsapp_header_title') {
                    headerType = value?.type || ''
                    headerValue = value?.value || ''
                  }

                  if (comp.componentKey === 'whatsapp_body') {
                    body = value || ''
                  }

                  if (comp.componentKey === 'whatsapp_footer') {
                    footer = value || ''
                  }

                  if (comp.componentKey === 'whatsapp_action_button') {
                    actionButtonComponentIds.push(comp.contentId)

                    if (value?.type === 'quick_reply') {
                      actions?.push({
                        id: comp.contentId,
                        type: 'quick_reply',
                        text: value.title,
                        quickReplies: (value.payload || []).map(q => ({
                          id: crypto.randomUUID(),
                          title: q
                        }))
                      })
                    } else {
                      actions?.push({
                        id: comp.contentId,
                        type: value?.type,
                        title: value?.title,
                        payload: value?.payload
                      })
                    }
                  }
                })
              })
            })

            return { headerType, headerValue, body, footer, actions }
          }

          const content = extractWhatsappContent(translation)

          setWhatsappHeaderType(content.headerType)
          setWhatsappHeaderContent(content.headerValue)
          setWhatsappValue(content.body)
          setWhatsappFooterText(content.footer)
          setWhatsappActionButtons(content.actions)

          setSelectedWhatsappConfigId(whatsappIdsData?.channelConfigId)
          setWhatsappConfigName(whatsappIdsData?.channelConfigName)
          setWhatsappSelectedTemplate('standard')
        } else if (templateTypeFromAPI === 'carousel') {
          const extractWhatsappCarouselData = response => {
            const data = response
            if (!data) {
              return null
            }
            const channelId = data.channelId
            const channelConfigId = data.channelConfiguration?.channelConfigId
            const channelConfigName = data.channelConfiguration?.channelConfigName
            const layoutGroups = data.layoutGroups || []

            const bodyGroup = layoutGroups.find(g =>
              g.contentUnits?.[0]?.components?.some(c => c.componentKey === 'whatsapp_body')
            )

            const bodyUnit = bodyGroup?.contentUnits?.[0]
            const bodyComponent = bodyUnit?.components?.find(c => c.componentKey === 'whatsapp_body')

            const bodyText = bodyComponent?.translations?.en || ''

            const cardsGroup = layoutGroups.find(g =>
              g.contentUnits?.some(unit => unit.components?.some(c => c.componentKey === 'whatsapp_header_title'))
            )

            const cards = []
            const cardIds = []

            cardsGroup?.contentUnits?.forEach(unit => {
              const header = unit.components.find(c => c.componentKey === 'whatsapp_header_title')
              const body = unit.components.find(c => c.componentKey === 'whatsapp_content')
              const buttons = unit.components.filter(c => c.componentKey === 'whatsapp_action_button')

              cards.push({
                id: unit.unitId,
                headerType: header?.translations?.en?.type || 'image',
                headerMediaFile: header?.translations?.en?.value || '',
                bodyText: body?.translations?.en || '',
                actionButtons: buttons?.map(a => {
                  const en = a.translations?.en

                  if (en?.type === 'quick_reply') {
                    return {
                      id: a.contentId,
                      type: 'quick_reply',
                      title: en.title,
                      quickReplies: (en.payload || []).map(q => ({
                        // ✅ QUICK REPLY FIX
                        id: crypto.randomUUID(),
                        title: q
                      }))
                    }
                  }
                  return {
                    id: a.contentId,
                    type: en?.type || '',
                    title: en?.title || '',
                    payload: en?.payload || ''
                  }
                })
              })

              cardIds.push({
                unitId: unit.unitId,
                headerId: header?.contentId,
                bodyId: body?.contentId,
                buttons: buttons.map(b => b.contentId)
              })
            })

            return {
              values: {
                bodyText,
                cards
              },

              ids: {
                body: {
                  groupId: bodyGroup?.groupId,
                  unitId: bodyUnit?.unitId,
                  contentId: bodyComponent?.contentId
                },

                cardsGroupId: cardsGroup?.groupId,

                cards: cardIds,
                channelId,
                channelConfigId,
                channelConfigName
              }
            }
          }
          const { values, ids } = extractWhatsappCarouselData(translation)

          // set UI
          setWhatsappValue(values.bodyText)
          setWhatsappCarouselCards(values.cards)
          setSelectedWhatsappConfigId(ids?.channelConfigId) // Channel config ID
          setWhatsappConfigName(ids?.channelConfigName)
          setWhatsappSelectedTemplate('carousel')
          setCampaignApiId(prev => ({
            ...prev,
            whatsapp: {
              ...prev?.whatsapp,
              carousel: ids
            }
          }))
        }
      } catch {}
    }
  }
  const fetchRcsTranslation = async (channelRcsId, type) => {
    const isPromotional = type === 'promotional'
    const isTransactional = type === 'transactional'

    if (!selectedCampaign.id || !channelRcsId) {
      return
    }

    try {
      let translation = null

      if (isPromotional) {
        translation = await GetPromotionalChannelTranslation(channelRcsId)
      } else if (isTransactional) {
        translation = await GetTransactionalChannelTranslation(channelRcsId)
      }
      setRcsExternalTemplateId(translation?.externalTemplateId)
      if (translation?.externalTemplateId && translation?.vendorId) {
        const dataDetails = await getExternalTemplateDetails(translation?.externalTemplateId)
        setRcsExternalTemplateData(dataDetails)
        setRcsVendorDataId(translation?.vendorId)
        const channelConfigId = translation?.channelConfiguration?.channelConfigId
        const channelConfigName = translation?.channelConfiguration?.channelConfigName
        setSelectedRcsConfigId(channelConfigId)
        setRCSConfigName(channelConfigName)
      }

      const templateTypeDetails = translation?.configuration?.template_type

      if (!translation?.layoutGroups?.length) {
        return
      }
      if (templateTypeDetails === 'text_message') {
        setTemplateType('text')
        const extractRcsIds = data => {
          let message = {}
          let actionButtons = []
          let fallback = {}

          data.layoutGroups.forEach(group => {
            group.contentUnits.forEach(unit => {
              unit.components.forEach(comp => {
                if (comp.componentKey === 'rcs_message') {
                  message = {
                    groupId: group.groupId,
                    unitId: unit.unitId,
                    contentId: comp.contentId
                  }
                }

                if (comp.componentKey === 'rcs_action_button') {
                  actionButtons.push({
                    contentId: comp.contentId,
                    groupId: group.groupId,
                    unitId: unit.unitId
                  })
                }

                if (comp.componentKey === 'rcs_fallback_sms_message') {
                  fallback = {
                    groupId: group.groupId,
                    unitId: unit.unitId,
                    contentId: comp.contentId
                  }
                }
              })
            })
          })

          return {
            channelId: data.channelId,
            channelConfigId: data.channelConfiguration?.channelConfigId,
            channelConfigName: data.channelConfiguration?.channelConfigName,
            message,
            actionButtons,
            fallback
          }
        }

        const rcsIdsData = extractRcsIds(translation)

        setCampaignApiId(prev => ({
          ...prev,
          rcs: rcsIdsData
        }))

        const extractRcsContent = data => {
          let messageText = ''
          let actions = []
          let fallbackText = ''

          data.layoutGroups.forEach(group => {
            group.contentUnits.forEach(unit => {
              unit.components.forEach(comp => {
                const value = comp.translations?.en

                if (comp.componentKey === 'rcs_message') {
                  messageText = value || ''
                }

                if (comp.componentKey === 'rcs_action_button') {
                  if (value?.type === 'quick_reply') {
                    actions?.push({
                      id: comp.contentId,
                      type: 'quick_reply',
                      title: en.title,
                      quickReplies: (en.payload || []).map(q => ({
                        id: crypto.randomUUID(),
                        title: q
                      }))
                    })
                  } else {
                    actions?.push({
                      id: comp.contentId,
                      type: value?.type,
                      title: value?.title,
                      payload: value?.payload
                    })
                  }
                }

                if (comp.componentKey === 'rcs_fallback_sms_message') {
                  fallbackText = value || ''
                }
              })
            })
          })

          return { messageText, actions, fallbackText }
        }

        const content = extractRcsContent(translation)

        setRCSValue(content.messageText)
        setTextActionButtons(content.actions)
        setSmsFallbackText(content.fallbackText)
        setSelectedRcsConfigId(rcsIdsData?.channelConfigId)
        setRCSConfigName(rcsIdsData?.channelConfigName)
      } else if (templateTypeDetails === 'rich_card_stand_alone') {
        setTemplateType('rich')
        const extractRcsRichCardsData = response => {
          const data = response?.data || response
          if (!data?.layoutGroups?.length) {
            return null
          }

          const cards = []
          const cardIds = []
          let fallback = {}
          let fallbackText = ''
          data.layoutGroups.forEach(group => {
            const groupConfig = group.configuration || {}

            const mediaHeight = groupConfig.media_height
            const cardOrientation = groupConfig.card_orientation

            group.contentUnits?.forEach(unit => {
              const comps = unit.components || []

              const fallbackComp = comps.find(c => c.componentKey === 'rcs_fallback_sms_message')
              if (fallbackComp) {
                fallback = {
                  groupId: group.groupId,
                  unitId: unit.unitId,
                  contentId: fallbackComp.contentId
                }
                fallbackText = fallbackComp.translations?.en || ''
                return
              }

              const media = comps.find(c => c.componentKey === 'rcs_media')
              const title = comps.find(c => c.componentKey === 'rcs_card_title')
              const description = comps.find(c => c.componentKey === 'rcs_card_description')
              const actions = comps.filter(c => c.componentKey === 'rcs_action_button')

              cards.push({
                id: unit.unitId,
                cardOrientation: cardOrientation,
                mediaHeight: mediaHeight,
                headerType: media?.translations?.en?.type || '',
                headerMediaFile: media?.translations?.en?.url?.trim() || '',
                titleText: title?.translations?.en || '',
                bodyText: description?.translations?.en || '',
                actionButtons: actions.map(a => {
                  const en = a.translations?.en

                  if (en?.type === 'quick_reply') {
                    return {
                      id: a.contentId,
                      type: 'quick_reply',
                      title: en.title,
                      quickReplies: (en.payload || []).map(q => ({
                        // ✅ QUICK REPLY FIX
                        id: crypto.randomUUID(),
                        title: q
                      }))
                    }
                  }
                  return {
                    id: a.contentId,
                    type: en?.type || '',
                    title: en?.title || '',
                    payload: en?.payload || ''
                  }
                })
              })

              // ---- IDS ----
              cardIds.push({
                groupId: group.groupId,
                unitId: unit.unitId,
                mediaId: media?.contentId,
                titleId: title?.contentId,
                descriptionId: description?.contentId,
                actionIds: actions.map(a => a.contentId)
              })
            })
          })

          return {
            values: {
              cards,
              fallbackText
            },
            ids: {
              channelId: data.channelId,
              channelConfigId: data.channelConfiguration?.channelConfigId,
              channelConfigName: data.channelConfiguration?.channelConfigName,
              cards: cardIds,
              fallback
            }
          }
        }
        const { values, ids } = extractRcsRichCardsData(translation)

        setRCards(values.cards)
        setSmsFallbackText(values.fallbackText)
        setSelectedRcsConfigId(ids?.channelConfigId)
        setRCSConfigName(ids?.channelConfigName)

        setCampaignApiId(prev => ({
          ...prev,
          rcs: {
            ...prev?.rcs,
            richCards: ids
          }
        }))
      } else if (templateTypeDetails === 'rich_card_carousel') {
        setTemplateType('rich_carousel')
        const extractRcsCarouselData = response => {
          const data = response?.data || response
          if (!data) {
            return null
          }

          const layoutGroups = data.layoutGroups || []

          const cards = []
          const cardIds = []
          let fallback = ''

          layoutGroups.forEach(group => {
            // ---------- FALLBACK ----------
            const fallbackUnit = group.contentUnits?.find(unit =>
              unit.components?.some(c => c.componentKey === 'rcs_fallback_sms_message')
            )

            if (fallbackUnit) {
              const fallbackComp = fallbackUnit.components.find(c => c.componentKey === 'rcs_fallback_sms_message')

              fallback = fallbackComp?.translations?.en || ''

              cardIds.push({
                fallback: {
                  groupId: group.groupId,
                  unitId: fallbackUnit.unitId,
                  contentId: fallbackComp?.contentId
                }
              })

              return
            }

            const groupConfig = group.configuration || {}

            const mediaHeight = groupConfig.media_height
            const cardOrientation = groupConfig.card_orientation
            // ---------- CARDS ----------
            group.contentUnits?.forEach(unit => {
              const media = unit.components.find(c => c.componentKey === 'rcs_media')
              const title = unit.components.find(c => c.componentKey === 'rcs_card_title')
              const description = unit.components.find(c => c.componentKey === 'rcs_card_description')
              const actions = unit.components.filter(c => c.componentKey === 'rcs_action_button')

              // ----- UI VALUES -----
              cards.push({
                id: unit.unitId,
                cardOrientation: cardOrientation,
                mediaHeight: mediaHeight,
                headerType: media?.translations?.en?.type || '',
                headerMediaFile: media?.translations?.en?.url?.trim() || '',
                titleText: title?.translations?.en || '',
                bodyText: description?.translations?.en || '',
                actionButtons: actions.map(a => {
                  const en = a.translations?.en

                  if (en?.type === 'quick_reply') {
                    return {
                      id: a.contentId,
                      type: 'quick_reply',
                      title: en.title,
                      quickReplies: (en.payload || []).map(q => ({
                        // ✅ QUICK REPLY FIX
                        id: crypto.randomUUID(),
                        title: q
                      }))
                    }
                  }
                  return {
                    id: a.contentId,
                    type: en?.type || '',
                    title: en?.title || '',
                    payload: en?.payload || ''
                  }
                })
              })

              // ----- IDS FOR UPDATE -----
              cardIds.push({
                groupId: group.groupId,
                unitId: unit.unitId,
                mediaId: media?.contentId,
                titleId: title?.contentId,
                descriptionId: description?.contentId,
                buttonIds: actions.map(b => b.contentId)
              })
            })
          })

          return {
            // ---------- UI ----------
            values: {
              cards,
              fallback
            },

            // ---------- IDS ----------
            ids: {
              channelId: data.channelId,
              channelConfigId: data.channelConfiguration?.channelConfigId,
              channelConfigName: data.channelConfiguration?.channelConfigName,
              cards: cardIds.filter(c => !c.fallback),
              fallback: cardIds.find(c => c.fallback)?.fallback || null
            }
          }
        }
        const { values, ids } = extractRcsCarouselData(translation)

        // UI state
        setRCards(values.cards)
        setSmsFallbackText(values.fallback)
        setSelectedRcsConfigId(ids?.channelConfigId)
        setRCSConfigName(ids?.channelConfigName)

        // store ids for update payload
        setCampaignApiId(prev => ({
          ...prev,
          rcs: {
            ...prev?.rcs,
            carousel: ids
          }
        }))
      }
    } catch {}
  }
  const getAIDescription = async (campaignChannelId, channelId) => {
    try {
      const queryParams = {
        channelId: channelId
      }
      const response = await api.get(`${generateSubjectUrl}/templates/${campaignChannelId}`, {
        params: queryParams
      })
      const data = response?.data?.data?.content_description
      return data
    } catch {}
  }
  const GetTemplateChannelTranslation = async (templateId, channelId) => {
    try {
      const response = await api.get(`${templateUrl}/${templateId}/channeldata/${channelId}`)

      const channelMessage = response?.data?.data
      return channelMessage
    } catch {}
  }

  const fetchEmailTemplateTranslation = async (templateId, channelDataId) => {
    if (templateId && channelDataId) {
      const translation = await GetTemplateChannelTranslation(templateId, channelDataId)
      const extractEmailIds = emailTranslation => {
        let subject = {}
        let preheader = {}
        let body = {}

        emailTranslation?.layoutGroups?.forEach(group => {
          group.contentUnits.forEach(unit => {
            unit.components.forEach(comp => {
              if (comp.componentKey === 'subject') {
                subject = {
                  groupId: group.groupId,
                  unitId: unit.unitId,
                  componentId: comp.contentId
                }
              }

              if (comp.componentKey === 'preheader_text') {
                preheader = {
                  groupId: group.groupId,
                  unitId: unit.unitId,
                  componentId: comp.contentId
                }
              }

              if (comp.componentKey === 'body_html') {
                body = {
                  groupId: group.groupId,
                  unitId: unit.unitId,
                  componentId: comp.contentId
                }
              }
            })
          })
        })

        return { subject, preheader, body }
      }
      const emailIds = extractEmailIds(translation)

      setCampaignApiId(prev => ({
        ...prev,
        email: {
          subject: emailIds.subject,
          preheader: emailIds.preheader,
          body: emailIds.body
        }
      }))
      const extractEmailContentToUI = emailTranslation => {
        let subject = ''
        let preheader = ''
        let body = ''

        emailTranslation?.layoutGroups?.forEach(group => {
          group.contentUnits.forEach(unit => {
            unit.components.forEach(comp => {
              const value = comp.translations?.en || ''

              if (comp.componentKey === 'subject') {
                subject = value
              }
              if (comp.componentKey === 'preheader_text') {
                preheader = value
              }
              if (comp.componentKey === 'body_html') {
                body = value
              }
            })
          })
        })

        return { subject, preheader, body }
      }
      const emailUI = extractEmailContentToUI(translation)
      setCampaignsubject(emailUI.subject)
      setPreHeader(emailUI.preheader)
      setEmailValue(emailUI.body)

      setEditorID(Number(translation?.configuration?.editorId) || 2)
    }
  }

  const fetchWhatsappTemplateTranslation = async (templateId, channelId) => {
    if (templateId && channelId) {
      let translation = await GetTemplateChannelTranslation(templateId, channelId)
      setWhatsappExternalTemplateId(translation?.externalTemplateId)

      if (translation?.externalTemplateId && translation?.vendorId) {
        const dataDetails = await getExternalTemplateDetails(translation?.externalTemplateId)
        setWhatsappExternalTemplateData(dataDetails)
        setWhatsappSelectedTemplate('')
        setWhatsappVendorDataId(translation?.vendorId)
        const channelConfigId = translation?.channelConfiguration?.channelConfigId
        const channelConfigName = translation?.channelConfiguration?.channelConfigName
        setSelectedWhatsappConfigId(channelConfigId)
        setWhatsappConfigName(channelConfigName)
      }
      if (translation?.configuration?.template_type === 'standard') {
        const extractWhatsappStandard = response => {
          const layoutGroups = response?.layoutGroups || []

          const getGroups = layoutType => layoutGroups.filter(g => g.layoutType === layoutType)

          const headerGroup = getGroups('HEADER')[0] || null
          const bodyGroup = getGroups('BLOCK')[0] || null
          const footerGroups = getGroups('FOOTER')

          const footerTextGroup = footerGroups.find(g => g.contentUnits?.[0]?.unitName === 'Footer') || null

          const actionButtonGroup = footerGroups.find(g => g.contentUnits?.[0]?.unitName === 'Action') || null

          const headerUnit = headerGroup?.contentUnits?.[0]
          const bodyUnit = bodyGroup?.contentUnits?.[0]
          const footerTextUnit = footerTextGroup?.contentUnits?.[0]
          const actionUnit = actionButtonGroup?.contentUnits?.[0]

          const headerComp = headerUnit?.components?.find(c => c.componentKey === 'whatsapp_header_title')

          const bodyComp = bodyUnit?.components?.find(c => c.componentKey === 'whatsapp_body')

          const footerComp = footerTextUnit?.components?.find(c => c.componentKey === 'whatsapp_footer')

          const actionButtons = actionUnit?.components || []

          return {
            headerType: headerComp?.translations?.en?.type || '',
            headerValue: headerComp?.translations?.en?.value || '',
            bodyText: bodyComp?.translations?.en || '',
            footerText: footerComp?.translations?.en || '',
            buttons: actionButtons.map(btn => {
              const en = btn.translations?.en || {}

              // ✅ HANDLE BOTH ARRAY AND STRING PAYLOAD
              let payloadValue = ''
              let quickReplies = []

              if (en.payload !== undefined && en.payload !== null) {
                if (Array.isArray(en.payload)) {
                  // Array: first item = value, full array = quickReplies
                  payloadValue = en.payload[0] || ''
                  quickReplies = en.payload.filter(item => item) // Remove empty strings
                } else {
                  // String: use as both value and single-item quickReply
                  payloadValue = en.payload
                  quickReplies = [en.payload].filter(item => item) // Remove empty strings
                }
              }

              return {
                id: btn.contentId,
                type: en.type || '',
                title: en.title || '',
                payload: payloadValue, // ALWAYS STRING
                quickReplies: quickReplies // ALWAYS ARRAY (empty if no payload)
              }
            })
          }
        }

        const result = extractWhatsappStandard(translation)

        // ---- SET STATES ----
        setWhatsappHeaderType(result?.headerType)
        setWhatsappHeaderContent(result?.headerValue)
        setWhatsappValue(result?.body)
        setWhatsappFooterText(result?.footer)
        setWhatsappActionButtons(result?.actions)
        setWhatsappSelectedTemplate('standard')
      } else if (translation?.configuration?.template_type === 'carousel') {
        const extractWhatsappButtons = (components = []) => {
          const buttons = []
          const actionIds = []

          components.forEach(component => {
            if (component.componentKey !== 'whatsapp_action_button') {
              return
            }

            const en = component.translations?.en
            if (!en) {
              return
            }

            const buttonId = component.contentId
            actionIds.push(buttonId)

            // QUICK REPLY BUTTON
            if (en.type === 'quick_reply') {
              buttons.push({
                id: buttonId,
                type: 'quick_reply',
                title: en.title || '',
                quickReplies: (en.payload || []).map(q => ({
                  id: crypto.randomUUID(),
                  title: q
                }))
              })
              return
            }

            // CTA BUTTONS (url / phone / copy_code)
            buttons.push({
              id: buttonId,
              type: en.type,
              title: en.title || '',
              payload: en.payload || ''
            })
          })

          return {
            buttons,
            actionIds
          }
        }

        const extractWhatsappCarouselCards = (layoutGroups = []) => {
          const bodyGroup = layoutGroups.find(g => g.contentUnits?.[0]?.unitName === 'Body Content')

          const cardGroup = layoutGroups.find(g => g.contentUnits?.[0]?.unitName?.startsWith('Card'))

          if (!bodyGroup || !cardGroup) {
            return { bodyText: '', cards: [], apiIds: {} }
          }

          // BODY
          const bodyUnit = bodyGroup.contentUnits[0]
          const bodyComponent = bodyUnit.components.find(c => c.componentKey === 'whatsapp_body')

          const bodyText = bodyComponent?.translations?.en || ''

          const apiIds = {
            bodyGroupId: bodyGroup.groupId,
            bodyUnitId: bodyUnit.unitId,
            bodyComponentId: bodyComponent?.contentId,
            cardsGroupId: cardGroup.groupId,
            cards: []
          }

          const cards = cardGroup.contentUnits.map(unit => {
            const card = {
              id: unit.unitId,
              headerType: '',
              headerContent: '',
              headerMediaFile: '',
              bodyText: '',
              actionButtons: [],
              ids: {
                headerId: null,
                bodyId: null,
                actionIds: []
              }
            }

            unit.components.forEach(component => {
              const en = component.translations?.en

              switch (component.componentKey) {
                case 'whatsapp_header_title':
                  card.headerType = en?.type || ''
                  if (en?.type === 'text') {
                    card.headerContent = en.value || ''
                  } else {
                    card.headerMediaFile = en.value || ''
                  }
                  card.ids.headerId = component.contentId
                  break

                case 'whatsapp_content':
                  card.bodyText = en || ''
                  card.ids.bodyId = component.contentId
                  break

                case 'whatsapp_action_button': {
                  const { buttons, actionIds } = extractWhatsappButtons([component])
                  card.actionButtons.push(...buttons)
                  card.ids.actionIds.push(...actionIds)
                  break
                }

                default:
                  break
              }
            })

            // Save API IDs
            apiIds?.cards?.push({
              unitId: unit.unitId,
              headerId: card.ids.headerId,
              bodyId: card.ids.bodyId,
              actionIds: card.ids.actionIds
            })

            return card
          })

          return {
            bodyText,
            cards,
            apiIds
          }
        }
        const { bodyText, cards, apiIds } = extractWhatsappCarouselCards(translation?.layoutGroups)

        setWhatsappValue(bodyText)
        setWhatsappCarouselCards(cards)
        setCampaignApiId(prev => ({
          ...prev,
          whatsapp: {
            ...prev.whatsapp,
            carousel: apiIds
          }
        }))
        setWhatsappSelectedTemplate('carousel')
      }
    }
  }

  const fetchSMSTemplateTranslation = async (templateId, channelId) => {
    if (templateId && channelId) {
      const translation = await GetTemplateChannelTranslation(templateId, channelId)
      setSmsExternalTemplateId(translation?.externalTemplateId)
      if (translation?.externalTemplateId && translation?.vendorId) {
        const dataDetails = await getExternalTemplateDetails(translation?.externalTemplateId)
        setSmsExternalTemplateData(dataDetails)
        setSmsVendorDataId(translation?.vendorId)
        const channelConfigId = translation?.channelConfiguration?.channelConfigId
        const channelConfigName = translation?.channelConfiguration?.channelConfigName
        setSelectedSmsConfigId(channelConfigId)
        setSmsConfigName(channelConfigName)
      }
      const groupId = translation?.layoutGroups?.[0]?.groupId || ''
      const unitId = translation?.layoutGroups?.[0]?.contentUnits?.[0]?.unitId || ''
      const componentId = translation?.layoutGroups?.[0]?.contentUnits?.[0]?.components?.[0]?.contentId || ''
      const translationalSmsValue = translation?.layoutGroups?.[0]?.contentUnits?.[0]?.components?.[0]?.translations?.en
      setCampaignApiId(prev => ({
        ...prev,
        sms: {
          groupId,
          unitId,
          componentId
        }
      }))
      setSmsValue(translationalSmsValue)
    }
  }

  const fetchRCSTemplateTranslation = async (templateId, channelId) => {
    if (templateId && channelId) {
      let translation = await GetTemplateChannelTranslation(templateId, channelId)

      setRcsExternalTemplateId(translation?.externalTemplateId)
      if (translation?.externalTemplateId && translation?.vendorId) {
        const dataDetails = await getExternalTemplateDetails(translation?.externalTemplateId)
        setRcsExternalTemplateData(dataDetails)
        setRcsVendorDataId(translation?.vendorId)
        const channelConfigId = translation?.channelConfiguration?.channelConfigId
        const channelConfigName = translation?.channelConfiguration?.channelConfigName
        setSelectedRcsConfigId(channelConfigId)
        setRCSConfigName(channelConfigName)
      }
      if (translation?.configuration?.template_type === 'text_message') {
        const extractRcsTextFull = rcsTranslation => {
          let groupId = '',
            unitId = '',
            messageComponentId = ''
          let fallbackGroupId = '',
            fallbackUnitId = '',
            fallbackComponentId = ''
          let messageText = '',
            fallbackText = ''
          const actionButtonComponentIds = []
          const actionButtons = []

          rcsTranslation?.layoutGroups?.forEach(group => {
            group.contentUnits.forEach(unit => {
              unit.components.forEach(comp => {
                const en = comp.translations?.en

                // MESSAGE TEXT
                if (unit.unitName === 'Message Content' && comp.componentKey === 'rcs_message') {
                  groupId = group.groupId
                  unitId = unit.unitId
                  messageComponentId = comp.contentId
                  messageText = en || ''
                }

                // ACTION BUTTONS
                if (unit.unitName === 'Message Content' && comp.componentKey === 'rcs_action_button') {
                  actionButtonComponentIds.push(comp.contentId)

                  if (en?.type === 'quick_reply') {
                    actionButtons.push({
                      id: comp.contentId,
                      type: 'quick_reply',
                      title: en.title,
                      quickReplies: (en.payload || []).map(q => ({
                        id: crypto.randomUUID(),
                        title: q
                      }))
                    })
                  } else {
                    actionButtons.push({
                      id: comp.contentId,
                      type: en?.type,
                      title: en?.title,
                      payload: en?.payload
                    })
                  }
                }

                // FALLBACK
                if (unit.unitName === 'Fallback' && comp.componentKey === 'rcs_fallback_sms_message') {
                  fallbackGroupId = group.groupId
                  fallbackUnitId = unit.unitId
                  fallbackComponentId = comp.contentId
                  fallbackText = en || ''
                }
              })
            })
          })

          return {
            ids: {
              groupId,
              unitId,
              messageComponentId,
              actionButtonComponentIds,
              fallbackGroupId,
              fallbackUnitId,
              fallbackComponentId
            },
            ui: {
              messageText,
              actionButtons,
              fallbackText
            }
          }
        }

        const { ids, ui } = extractRcsTextFull(translation)

        setCampaignApiId(prev => ({
          ...prev,
          rcs: {
            ...prev.rcs,
            text: ids
          }
        }))

        setTemplateType('text')
        setRCSValue(ui.messageText)
        setTextActionButtons(ui.actionButtons)
        setSmsFallbackText(ui.fallbackText)
      }
      if (translation?.configuration?.template_type === 'rich_card_stand_alone') {
        setTemplateType('rich')

        const extractRcsStandaloneToUI = response => {
          const layoutGroup = response?.layoutGroups?.[0]
          const contentUnit = layoutGroup?.contentUnits?.[0]
          const components = contentUnit?.components || []

          // ----- UI DATA -----
          const card = {
            cardOrientation: layoutGroup?.configuration?.card_orientation || ' ',
            mediaHeight: layoutGroup?.configuration?.media_height || ' ',
            headerType: '',
            headerMediaFile: '',
            titleText: '',
            bodyText: '',
            actionButtons: []
          }

          // ----- ID STORAGE -----
          let mediaId = '',
            titleId = '',
            descId = ''
          const actionButtonIds = []

          components.forEach(comp => {
            const en = comp.translations?.en

            if (comp.componentKey === 'rcs_media') {
              card.headerType = en?.type || ' '
              card.headerMediaFile = en?.url || ' '
              mediaId = comp.contentId
            }

            if (comp.componentKey === 'rcs_card_title') {
              card.titleText = en || ' '
              titleId = comp.contentId
            }

            if (comp.componentKey === 'rcs_card_description') {
              card.bodyText = en || ' '
              descId = comp.contentId
            }

            if (comp.componentKey === 'rcs_action_button') {
              actionButtonIds.push(comp.contentId)
              if (en?.type === 'quick_reply') {
                card.actionButtons.push({
                  id: comp.contentId,
                  type: 'quick_reply',
                  title: en.title,
                  quickReplies: (en.payload || []).map(q => ({ id: crypto.randomUUID(), title: q }))
                })
              } else {
                card.actionButtons.push({
                  id: comp.contentId,
                  type: en?.type,
                  title: en?.title,
                  payload: en?.payload
                })
              }
            }
          })

          // ----- Fallback -----
          const fallbackGroup = response?.layoutGroups?.find(g => g.contentUnits?.[0]?.unitName === 'Fallback')
          let fallbackText = ''
          let fallbackGroupId = '',
            fallbackUnitId = '',
            fallbackComponentId = ''
          if (fallbackGroup) {
            const fallbackUnit = fallbackGroup.contentUnits[0]
            const fallbackComp = fallbackUnit.components[0]
            fallbackText = fallbackComp?.translations?.en || ' '
            fallbackGroupId = fallbackGroup.groupId
            fallbackUnitId = fallbackUnit.unitId
            fallbackComponentId = fallbackComp?.contentId
          }

          return {
            card,
            ids: {
              groupId: layoutGroup?.groupId,
              unitId: contentUnit?.unitId,
              mediaId,
              titleId,
              descId,
              actionButtonIds
            },
            fallback: {
              text: fallbackText,
              groupId: fallbackGroupId,
              unitId: fallbackUnitId,
              componentId: fallbackComponentId
            }
          }
        }

        const { card: rcsCard, ids, fallback } = extractRcsStandaloneToUI(translation)

        setRCards([rcsCard]) // standalone = 1 card only

        // Store IDs in state
        setCampaignApiId(prev => ({
          ...prev,
          rcs: {
            ...prev.rcs,
            standalone: {
              groupId: ids.groupId || '',
              unitId: ids.unitId || '',
              mediaComponentId: ids.mediaId || '',
              titleComponentId: ids.titleId || '',
              descComponentId: ids.descId || '',
              actionButtonIds: ids.actionButtonIds || [],
              fallback
            }
          }
        }))

        // Set fallback UI state
        setSmsFallbackText(fallback.text || ' ')
      } else if (translation?.configuration?.template_type === 'rich_card_carousel') {
        setTemplateType('rich_carousel')

        // -------------------------------
        // CARD EXTRACTION
        // -------------------------------
        const mapApiResponseToCards = apiResponse => {
          const carouselGroup = apiResponse?.layoutGroups?.[0]
          if (!carouselGroup) {
            return []
          }

          const carouselApiId = {
            groupId: carouselGroup.groupId,
            cardUnits: []
          }

          const cards = carouselGroup.contentUnits.map(unit => {
            const card = {
              id: unit.unitId,
              unitName: unit.unitName,
              headerType: 'none',
              headerMediaFile: null,
              titleText: '',
              bodyText: '',
              actionButtons: [],
              cardOrientation: carouselGroup.configuration?.card_orientation || 'vertical',
              mediaHeight: carouselGroup.configuration?.media_height || 'medium',
              ids: {
                mediaId: null,
                titleId: null,
                descId: null,
                actionIds: []
              }
            }

            unit.components.forEach(component => {
              const en = component.translations?.en

              switch (component.componentKey) {
                case 'rcs_media':
                  card.headerType = en?.type || 'image'
                  card.headerMediaFile = en?.url || null
                  card.ids.mediaId = component.contentId
                  break

                case 'rcs_card_title':
                  card.titleText = en || ' '
                  card.ids.titleId = component.contentId
                  break

                case 'rcs_card_description':
                  card.bodyText = en || ' '
                  card.ids.descId = component.contentId
                  break

                case 'rcs_action_button':
                  card.actionButtons.push({
                    id: component.contentId,
                    type: en?.type,
                    title: en?.title,
                    payload: en?.payload
                  })
                  card.ids.actionIds.push(component.contentId)
                  break

                default:
                  break
              }
            })

            carouselApiId.cardUnits.push({
              unitId: unit.unitId,
              mediaId: card.ids.mediaId,
              titleId: card.ids.titleId,
              descId: card.ids.descId,
              actionIds: card.ids.actionIds
            })

            return card
          })

          setCampaignApiId(prev => ({
            ...prev,
            rcs: {
              ...prev.rcs,
              carousel: carouselApiId
            }
          }))

          return cards
        }

        // -------------------------------
        // FALLBACK EXTRACTION
        // -------------------------------
        const extractFallback = apiResponse => {
          const fallbackGroup = apiResponse?.layoutGroups.find(g => g.contentUnits?.[0]?.unitName === 'Fallback')

          if (!fallbackGroup) {
            return
          }

          const fallbackUnit = fallbackGroup.contentUnits[0]
          const fallbackComponent = fallbackUnit.components[0]

          setSmsFallbackText(fallbackComponent.translations?.en || ' ')

          setCampaignApiId(prev => ({
            ...prev,
            rcs: {
              ...prev.rcs,
              fallback: {
                groupId: fallbackGroup.groupId,
                unitId: fallbackUnit.unitId,
                contentId: fallbackComponent.contentId
              }
            }
          }))
        }

        const cardsData = mapApiResponseToCards(translation)
        extractFallback(translation)

        setRCards(cardsData)
      }

      setIsRCSContentModified(false)
    }
  }
  const getTemplate = async id => {
    try {
      const response = await api.get(`${templateUrl}/${id}`)
      return response?.data.data
    } catch {}
  }
  const getConfigVendorList = async (channelId, vendorId, channel) => {
    try {
      const response = await api.get(`${GetSettings}/channel/${channelId}/vendor/${vendorId}`)
      const configurationList = response?.data?.data
      if (channel === 'whatsapp') {
        setVerifiedWhatsappSmtpConfigList(configurationList)
      } else if (channel === 'sms') {
        setVerifiedSmsSmtpConfigList(configurationList)
      } else if (channel === 'rcs') {
        setVerifiedRcsSmtpConfigList(configurationList)
      } else {
        setVerifiedSmtpConfigList(configurationList)
      }
      return response?.data
      // return response?.data.data
    } catch {}
  }
  const sendTestEmail = async ({ emailId, subject, content }) => {
    try {
      const attachmentUrls = (attachments || []).map(attachment => attachment.url)
      const payload = {
        to_email: emailId,
        subject: subject,
        html_content: content,
        // API omits the key entirely when there are no attachments, rather than
        // sending an empty array.
        ...(attachmentUrls.length > 0 && { attachments: attachmentUrls })
      }

      const response = await api.post(
        `${GetSettings}/channel/${emailChannelId}/configuration/${selectedEmailConfigId}/sendTestMessage`,
        payload,
        { skipGlobalToast: true }
      )
      return {
        success: response?.status === 200,
        message: response?.data?.data || 'Test email sent successfully'
      }
    } catch (error) {
      return {
        success: false,
        message: error?.response?.data?.message || error?.response?.data?.error || 'Failed to send test email'
      }
    }
  }
  const sendTestWhatsapp = async ({ number } = {}) => {
    try {
      const payload = {
        phone_number: number,
        external_template_id: whatsappExternalTemplateId,
        payload: {
          template_name: whatsappExternalTemplateData?.key,
          broadcast_name: 'test_broadcast'
        }
      }
      const response = await api.post(
        `${GetSettings}/channel/${whatsappChannelId}/vendor/${whatsappVendorDataId}/sendTestMessage`,
        payload,
        { skipGlobalToast: true }
      )
      return {
        success: response?.status === 200,
        message:
          response?.data?.data?.message ||
          (response?.status === 200 ? 'Whatsapp message sent successfully' : 'Failed to send test Whatsapp message')
      }
    } catch (error) {
      return {
        success: false,
        message:
          error?.response?.data?.message || error?.response?.data?.error || 'Failed to send test Whatsapp message'
      }
    }
  }
  const sendTestRCS = async ({ number } = {}) => {
    try {
      const customParam = rcsExternalTemplateData?.map_data?.reduce((index, item) => {
        index[item.template_field_name] = item.matched_system_column
        return index
      }, {})
      const payload = {
        phone_number: number,
        payload: {
          templateName: rcsExternalTemplateData?.key || 'Test',
          customParam: customParam
        }
      }
      const response = await api.post(
        `${GetSettings}/channel/${rcsChannelId}/vendor/${rcsVendorDataId}/sendTestMessage`,
        payload,
        { skipGlobalToast: true }
      )
      return {
        success: response?.status === 200,
        message:
          response?.data?.data?.message ||
          (response?.status === 200 ? 'RCS message sent successfully' : 'Failed to send test RCS message')
      }
    } catch (error) {
      return {
        success: false,
        message: error?.response?.data?.message || error?.response?.data?.error || 'Failed to send test RCS message'
      }
    }
  }

  const values = useMemo(() => ({
    selectedScheduleCampaign,
    setSelectedScheduleCampaign,
    isEmailContentModified,
    setIsEmailContentModified,
    isWhatsappContentModified,
    setIsWhatsappContentModified,
    isSmsContentModified,
    setIsSmsContentModified,
    isRCSContentModified,
    setIsRCSContentModified,
    getAIDescription: getAIDescription,
    isCampaignSetupModified,
    setIsCampaignSetupModified,
    campaignSaveStatus,
    setCampaignSaveStatus,
    isCampaignScheduleModified,
    setIsCampaignScheduleModified,
    campaignDirection,
    setCampaignMessageID,
    setCamapaignDirection,
    selectedPreviewTab,
    setSelectedPreviewTab,
    preHeaderError,
    setPreHeaderError,
    enableNextStep,
    setEnableNextstep,
    activeChannelStep,
    setActiveChannelStep,
    activePreviewStep,
    setActivePreviewStep,
    tagListData,
    setTagListData,
    selectedChannelTab,
    setSelectedChannelTab,
    setBeefreeData,
    beefreeData,
    selectedCampaignChannelId,
    setSelectedCampignChannelId,
    emailChannelId,
    setEmailChannelId,
    whatsappChannelId,
    setWhatsappChannelId,
    smsChannelId,
    setSmsChannelId,
    rcsChannelId,
    setRCSChannelId,
    emailCampaignChannelId,
    setEmailCampaignChannelId,
    whatsappCampaignChannelId,
    setWhatsappCampaignChannelId,
    smsCampaignChannelId,
    setSmsCampaignChannelId,
    selectedChannels,
    setSelectedChannels,
    templateSupportedChannels,
    setTemplateSupportedChannels,
    isCampaignChannelsModified,
    setIsCampaignChannelsModified,
    previousUserChannels,
    setPreviousUserChannels,
    updatedEnabledChannels,
    setUpdatedEnabledChannels,
    updatedDisabledChannels,
    setUpdatedDisabledChannels,
    enableEmail,
    setEnableEmail,
    enableWhatsapp,
    setEnableWhatsapp,
    enableRCS,
    setEnableRCS,
    enableSms,
    setEnableSms,
    enableRCS,
    setEnableRCS,
    campaignname,
    setCampaignname,
    selectedSegments,
    setSelectedSegments,
    audienceSegments,
    setAudienceSegments,
    selectCategories,
    setSelectCategories,
    selectAudienceSettings,
    setSelectAudienceSettings,
    campaignListData,
    setCampaignListData,
    selectedSegmentCampaignList,
    setSelectedSegmentCampaignList,
    getSelectedSegmentCampaignList,
    campaignCategoryList,
    whatsappExternalTemplateId,
    setWhatsappExternalTemplateId,
    rcsExternalTemplateId,
    setRcsExternalTemplateId,
    smsExternalTemplateId,
    setSmsExternalTemplateId,
    whatsappExternalTemplateData,
    setWhatsappExternalTemplateData,
    rcsExternalTemplateData,
    setRcsExternalTemplateData,
    smsExternalTemplateData,
    setSmsExternalTemplateData,
    whatsappVendorDataId,
    setWhatsappVendorDataId,
    rcsVendorDataId,
    setRcsVendorDataId,
    smsVendorDataId,
    setSmsVendorDataId,
    setCampaignCategoryList,
    archiveListData,
    setArchiveListData,
    smsValue,
    setSmsValue,
    rcsValue,
    setRCSValue,
    emailValue,
    setEmailValue,
    whatsappValue,
    setWhatsappValue,
    campaignsubject,
    setCampaignsubject,
    campaignSenderName,
    setCampaignSenderName,
    preHeader,
    setPreHeader,
    attachments,
    setAttachments,
    fromEmail,
    setFromEmail,
    replyToEmail,
    setReplyToEmail,
    rawHtml,
    setRawHtml,
    rawJSON,
    setRawJSON,
    selectedCampaign,
    setSelectedCampaign,
    campaignSMSData,
    setCampaignSMSData,
    campaignWhatsappData,
    setCampaignWhatsappData,
    campaignEmailData,
    setCampaignEmailData,
    previewSMSData,
    setPreviewSMSData,
    previewWhatsappData,
    setPreviewWhatsappData,
    previewEmailData,
    setPreviewEmailData,
    selectedTemplateId,
    setSelectedTemplateId,
    isTemplateModeSelected,
    setIsTemplateModeSelected,
    selectedEmailConfigId,
    setSelectedEmailConfigId,
    previousSelectedTemplateId,
    setPreviousSelectedTemplateId,
    campaignSendDt,
    setCampaignSendDt,
    campaignSchedule,
    setCampaignSchedule,
    smsContentDescription,
    setSmsContentDescription,
    whatsappContentDescription,
    setWhatsappContentDescription,
    emailContentDescription,
    setEmailContentDescription,
    emailSubject,
    setEmailSubject,
    SMSData,
    setSMSData,
    WhatsappData,
    setWhatsappData,
    EmailData,
    setEmailData,
    tags,
    setTags,
    mergetags,
    setMergeTags,
    selectedConfig,
    setSelectedConfig,
    editorID,
    setEditorID,
    emailCampaignContentId,
    setEmailCampaignContentId,
    whatsappCampaignContentId,
    setWhatsappCampaignContentId,
    smsCampaignContentId,
    setSmsCampaignContentId,
    campaignDate,
    setCampaignDate,
    setCampaignChannelData,
    campaignChannelData,
    mailpitID,
    setMailpitID,
    templateType,
    setTemplateType,
    rcards,
    setRCards,
    emailConfigName,
    setEmailConfigName,
    whatsappConfigName,
    setWhatsappConfigName,
    smsConfigName,
    setSmsConfigName,
    rcsConfigName,
    setRCSConfigName,
    campaignsCount,
    setCampaignsCount,
    trackEngagement,
    selectedTemplateName,
    setSelectedTemplateName,
    setTrackEngagement,
    isCampaignValid,
    setIsCampaignValid,
    campaignValidationCheckList,
    isSelectedSendNow,
    setIsSelectedSendNow,
    isProcessing,
    setIsProcessing,
    isNextStepLoading,
    setIsNextStepLoading,
    isAiLoading,
    setIsAiLoading,
    selectedChannelId,
    setSelectedChannelId,
    apiData,
    setApiData,
    activeChannel,
    setActiveChannel,
    setCampaignValidationCheckList,
    resetCampaign: resetCampaign,
    validateCampaign: validateCampaign,
    updateIgnoredValidations: updateIgnoredValidations,
    getMergeTags: getMergeTags,
    sendCampaignMailToMailpit: sendCampaignMailToMailpit,
    campaignFilterList,
    setCampaignFilterList,
    campaignOtherFilterList,
    setCampaignOtherFilterList,
    hasTagFilter,
    setHasTagFilter,
    getEmailPayload: getEmailPayload,
    getSmsPayload: getSmsPayload,
    setSelectedCampignChannelId,
    selectedCampaignChannelId,
    selectedSmsConfigId,
    setSelectedSmsConfigId,
    selectedWhatsappConfigId,
    setSelectedWhatsappConfigId,
    selectedRcsConfigId,
    setSelectedRcsConfigId,
    campaignApiId,
    setCampaignApiId,
    whatsappHeaderType,
    setWhatsappHeaderType,
    whatsappHeaderMediaFile,
    setwhatsappHeaderMediaFile,
    whatsappFooterText,
    setWhatsappFooterText,
    whatsappSelectedTemplate,
    setWhatsappSelectedTemplate,
    whatsappActionButtons,
    setWhatsappActionButtons,
    whatsappHeaderContent,
    setWhatsappHeaderContent,
    whatsappCarouselCards,
    setWhatsappCarouselCards,
    whatsappHeaderLink,
    setWhatsappHeaderLink,
    getWhatsappPayload: getWhatsappPayload,
    getWhatsappStandardPayload: getWhatsappStandardPayload,
    fetchWhatsappTranslation: fetchWhatsappTranslation,
    fetchEmailTranslation: fetchEmailTranslation,
    fetchSmsTranslation: fetchSmsTranslation,
    fetchRcsTranslation: fetchRcsTranslation,
    fetchWhatsappTemplateTranslation: fetchWhatsappTemplateTranslation,
    fetchEmailTemplateTranslation: fetchEmailTemplateTranslation,
    fetchSMSTemplateTranslation: fetchSMSTemplateTranslation,
    fetchRCSTemplateTranslation: fetchRCSTemplateTranslation,
    textActionButtons,
    setTextActionButtons,
    getTemplate: getTemplate,
    smsFallbackText,
    setSmsFallbackText,
    getRCSPayload: getRCSPayload,
    getWhatsappPayloadConfiguration: getWhatsappPayloadConfiguration,
    fetchTemplateForSingleChannel: fetchTemplateForSingleChannel,
    getConfigVendorList: getConfigVendorList,
    getQuickStats: getQuickStats,
    sendTestEmail: sendTestEmail,
    sendTestWhatsapp: sendTestWhatsapp,
    sendTestRCS: sendTestRCS,
    campaignActiveStep,
    setCampaignActiveStep
  }))

  return <CampaignContext.Provider value={values}>{children}</CampaignContext.Provider>
}
export { CampaignContext, CampaignProvider }
